/**
 * 全站雙語翻譯
 * zh: 繁體中文, en: English
 */
export const LANG_ZH = 'zh';
export const LANG_EN = 'en';

export const translations = {
  zh: {
    // Header / 導覽列
    a11y: {
      skipToContent: '跳至主內容',
      openMenu: '開啟選單',
      closeMenu: '關閉選單',
      mainNavigation: '主要導覽',
    },
    nav: {
      home: '首頁',
      eventsBooking: '預約場次',
      myReservations: '我的預約',
      activities: '活動總覽',
      activitiesIntro: '活動介紹',
      announcements: '最新公告',
      learningResources: '學習資源',
      courseGuide: '修課說明',
      regulationsForms: '法規表單',
      faq: '常見問題',
      about: '關於我們',
      contact: '聯絡我們',
      englishTest: '培力英檢(考試報名)',
      englishTestEdit: '培力英檢(資料修正)',
      englishLearningPassport: '英語實踐歷程護照',
      myProgress: '我的進度',
      myRecord: '我的紀錄',
      speakingPortfolio: '口說紀錄',
      classCreditAllocation: '課堂加分配置',
      groupTask: '今天要做',
      groupExplore: '探索',
      login: '登入',
      studentLogin: '登入',
      studentAccount: '我的帳號',
      backToStudentAccount: '回到我的帳號',
      studentLogout: '登出',
      adminEntry: '管理員登入',
    },
    // Footer / 頁尾
    footer: {
      centerName: 'EMI 全英語卓越教學中心',
      centerNameShort: 'EMI 中心',
      contact: '聯絡我們',
      copyright: '© 國立中山大學 EMI 全英語卓越教學中心 版權所有',
      reservationSystem: '英語增能活動預約系統',
      developedBy: '網站開發：',
      totalViews: '總瀏覽人次',
      todayViews: '當日瀏覽人次',
    },
    // 首頁 EventList
    home: {
      loading: '載入中...',
      loadingEvents: '載入活動列表中...',
      checkReservation: '查詢預約紀錄',
      faq: '常見問題',
      activityIntro: '活動介紹',
      notice: '重要通知',
      noticeSurveyBefore: '這個學期已經簽到參加過 English Table 或 English Club 的同學，下半學期再次預約前請先填寫',
      noticeSurveyLink: '問卷',
      noticeSurveyAfter: '。還沒簽到參加過的不用填。',
      ruleUpdate: '活動規定修改',
      ruleNoStamp: '114-1學期起不再提供活動補蓋章服務，請同學們務必準時參加活動。',
      ruleNoWalkIn: '活動不開放候補（含現場與線上），額滿請改選其他場次並提前完成預約。',
      month: '月',
      list: '清單',
      today: '今天',
      prevMonth: '上個月',
      nextMonth: '下個月',
      prevWeek: '上週',
      nextWeek: '下週',
      gotIt: '我知道了',
      // 使用說明彈窗
      usageTitle: '預約系統使用說明',
      usageLoginTitle: '用單一入口登入',
      usageLogin: '請用學號，以及 sso.nsysu.edu.tw 的密碼。不必另外建立帳號，第一次登入就會開通。以前在這個網站自設的密碼不能再登入。',
      usageCampusTitle: '用單一入口登入',
      usageCampusLogin: '輸入學號，以及 sso.nsysu.edu.tw 的密碼。不必另外建立帳號，第一次登入就會開通。',
      usageCampusPassword: '以前在這個網站自設的密碼不能再登入。忘記密碼、預設密碼或密碼到期，請先到單一入口處理。',
      usageCampusMail: '第一次登入後，到「我的帳號」確認收信信箱並輸入驗證碼。啟動前不能預約。',
      usageRule: '活動規定修改：',
      usageBlacklist: '同一學期內，若同學累積兩次違規紀錄，將被列入黑名單兩週。',
      usageViolations: '違規行為包括：',
      usageV1: '成功預約但未到場',
      usageV2: '活動中無正當理由中途離席',
      usageV3: '參加各項英語增能活動者，如於活動開始後5分鐘才抵達現場，亦視同違規',
      usageCancel: '若要取消，請先登入並開啟「我的預約」，在該筆畫面上的截止時間前輸入預約信裡的驗證碼。截止時間依活動類型而定。',
      usageCancelEn: 'To cancel, sign in and open My Reservations. Enter the code from your booking email before the deadline shown on that reservation. The deadline depends on the activity type.',
      usageButtonPrimary: '我知道了',
      usageButtonSecondary: 'Noted',
      noted: 'Noted',
      eventDetailsToggle: '展開或收合活動摘要',
      eventStatusOpen: '可預約',
      eventStatusClosed: '目前無法預約',
      surveyRequiredBadge: '須先填寫問卷（ET／EC）',
      spotsLeftLabel: '剩餘名額',
      calendarAlertFull: '此活動已額滿。',
      calendarAlertStarted: '活動已開始，無法預約。',
      calendarAlertNotOpen: '尚未開放預約。開放時間：{{start}} — {{end}}',
      calendarAlertPastDeadline: '已超過預約時間，無法預約。',
      eventHoverBadgeOpen: '可預約',
      eventHoverBadgeFull: '已額滿',
      eventHoverBadgeNotOpenYet: '尚未開放',
      eventHoverBadgeReservationEnded: '預約已結束',
      eventHoverBadgeEventStarted: '活動已開始',
      eventHoverBadgeUnavailable: '不可預約',
      eventHoverSurveyShort: '問卷',
      eventHoverSurveyAria: '此場次須先完成問卷方可預約',
      eventHoverSpotsPrefix: '剩餘名額：',
      eventHoverLocationLabel: '地點：',
      eventHoverCardAria: '活動預覽摘要',
      eventCtaViewDetail: '查看詳情',
      eventCtaBookNow: '立即預約',
    },
    // 活動介紹
    activities: {
      title: '活動介紹',
      filterEmptyTitle: '此分類目前沒有場次',
      filterEmptyDesc: '請改選其他活動類型，或查看全部活動。',
      showAllActivities: '顯示全部活動',
      noEventsTitle: '目前沒有開放場次',
      noEventsDesc: '現在可能是假期或尚未公告場次。可先看活動介紹、查已有預約，或用 5 分鐘練習暖身。',
      noEventsCtaActivities: '先看活動介紹',
      noEventsCtaReservations: '查我的預約',
      noEventsCtaPractice: '先練 5 分鐘',
      englishTable: '英語桌（English Table）',
      englishClub: '英語俱樂部（English Club）',
      internationalForum: '國際論壇（International Forum）',
      jobTalk: '就業講座（Job Talk）',
      jobTalkFull: 'Job Talk: Interview and Career English',
      // English Table
      etDesc: 'English Table 是短時段的英語交流活動，常搭配課程主題或教師規劃進行。學生可以在小桌討論中練習表達課程內容、分享觀點，適合想用英文談課堂主題但不想一次參加長時間活動的同學。',
      etCourseColearning: '課程共學',
      etCourseColearningDesc: '結合EMI英語授課課程，打造出多元的話題性與雙語的學習環境。',
      etInternational: '國際交流',
      etInternationalDesc: '結合主題課程，交流國際文化議題，同步培養英語能力與國際視野。',
      // English Club
      ecDesc: 'English Club 以主題討論和互動練習為主，由外籍講師或業師引導學生開口表達。活動重點是增加口說練習量、建立討論自信，適合想在輕鬆情境中練英文的同學。',
      ecFeatures: '活動特色',
      ecFeaturesDesc: '透過專業外籍講師的引導，學生能在輕鬆的環境中自然提升英語溝通能力，並培養跨文化理解與批判性思維。',
      // International Forum
      ifDesc: 'International Forum 以國際議題、文化差異或生活時事為討論主題，讓本地學生與國際學生交流觀點。學生可以練習用英文說明自己的文化、理解不同背景的想法，適合想拓展國際視野的同學。',
      ifGoals: '活動目標',
      ifGoalsDesc: '促進跨文化理解，建立國際友誼，並在討論中提升英語表達與溝通技巧。',
      // Job Talk
      jtDesc: 'Job Talk 聚焦職涯英文，包含自我介紹、面試回答、履歷故事和職場溝通。活動通常以情境演練或討論方式進行，適合想準備面試、交換計畫、實習或未來職場表達的同學。',
      jtFeatures: '活動特色',
      jtFeaturesDesc: '透過實際的角色扮演、模擬面試，以及以履歷為基礎的口語活動，學生將練習職場中真正需要的英語，學會清楚、專業且有說服力地溝通。',
      jtObjectives: '學習目標',
      jtObjectivesDesc: '這些活動專為加強培力英檢的核心目標──口語能力（包含流暢度、發音與自信的表達）──而設計，幫助參與者培養在培力英檢架構與當今全球職場中最受重視的溝通技巧。',
      writingWorkshop: '英文寫作工坊',
      wwDesc: '英文寫作工坊提供寫作輔導、資源與活動，協助學生強化學術與實用英文寫作。報名與活動資訊請至官網查詢（本服務由寫作工坊獨立辦理，非 EEARS 預約）。',
      photoCount: '張',
    },
    activitiesPage: {
      title: '活動介紹與預約',
      kicker: 'Activity guide',
      overviewTitle: '先了解活動差異，再選擇適合自己的場次',
      overviewLead: '本頁整理中心主要活動的學習情境、進行方式與預約入口。若已知道想參加的類型，也可以直接前往日曆查看開放場次。',
      bookFromCalendar: '前往日曆預約',
      flowLead: '從選擇活動到準時參與，四個步驟完成預約與學習紀錄累積。',
      step1ToolsKicker: 'Step 01 helpers',
      wordBridgeToolTitle: '語彙連橋',
      wordBridgeToolLead: '透過字彙分組挑戰，推估適合的入門活動。',
      wordBridgeToolCta: '開始語彙連橋',
      wordBridgeToolEmpty: '完成一場語彙連橋後，這裡會依你的表現推薦活動。',
      wordBridgeToolLevel: '最近推估層級：{{level}}',
      practiceResourcesCta: '前往學習資源練習',
      styleToolTitle: '學習型態',
      styleToolLead: '選擇學習節奏與加強方向，取得活動型態建議（僅本次瀏覽有效）。',
      styleToolCta: '填寫學習型態',
      styleToolEdit: '調整學習型態',
      styleToolSummary: '節奏：{{density}}；加強：{{focus}}',
      recommendedActivities: '建議活動',
      wordBridgeCta: '簡單測試英語能力',
      catalogKicker: 'Programs',
      catalogTitle: '活動類型',
      catalogLead: '先看活動目標與適合情境，再決定要預約哪一類。卡片順序每次瀏覽會輪換，方便認識不同活動。若想練課堂主題選 English Table；想增加口說練習選 English Club；想準備職涯表達選 Job Talk；想強化寫作可至英文寫作工坊官網。實際開放類型以本頁與日曆為準。',
      scheduleKicker: 'Schedule',
      scheduleTitle: '活動時間整理',
      scheduleLead: '下表整理各類活動的常見時間與形式；實際日期、地點、名額與是否開放預約，請以日曆頁公告為準。',
      tableActivity: '活動',
      tableTime: '常見時間',
      tableFormat: '形式',
      tableBooking: '預約',
      tableBookingLink: '查看場次',
      calendarTitle: '查看近期開放場次',
      fitLabel: '適合對象',
      formatLabel: '活動形式',
      durationLabel: '常見時間',
      etImageAlt: '學生圍桌討論課程主題的學習情境',
      ecImageAlt: '學生在小組中練習英文口說與討論',
      ifImageAlt: '本地與國際學生交流文化議題的活動情境',
      jtImageAlt: '學生參與職涯英語與面試練習的活動情境',
      etFit: '想用英文討論課程內容、快速練習表達',
      ecFit: '想增加開口練習、熟悉英文討論節奏',
      ifFit: '想和國際學生交流、練習文化與議題表達',
      jtFit: '想準備面試、履歷故事或職場英文',
      etFormat: '教師課程搭配、小桌交流',
      ecFormat: '外籍講師引導、主題討論',
      ifFormat: '跨文化議題、交流分享',
      jtFormat: '情境演練、職涯溝通練習',
      etDuration: '約 30 分鐘',
      ecDuration: '依公告場次',
      ifDuration: '依公告場次',
      jtDuration: '依公告場次',
      etSchedule: '約 30 分鐘，常搭配課程或教師規劃安排',
      ecSchedule: '依每學期公告場次，通常以主題討論形式進行',
      ifSchedule: '依中心公告場次，配合國際交流主題安排',
      jtSchedule: '依中心公告場次，配合面試、履歷或職涯主題安排',
      etVisual1: '課程主題',
      etVisual2: '小桌討論',
      etVisual3: '即時練習',
      ecVisual1: '外籍講師',
      ecVisual2: '主題討論',
      ecVisual3: '口說自信',
      ifVisual1: '國際學生',
      ifVisual2: '文化議題',
      ifVisual3: '交流表達',
      jtVisual1: '面試演練',
      jtVisual2: '履歷故事',
      jtVisual3: '職場英文',
      visitExternalSite: '前往官網',
      wwFit: '想系統化練習學術或實用英文寫作',
      wwFormat: '寫作輔導、資源與中心活動',
      wwDuration: '依寫作工坊公告',
      wwVisual1: '寫作輔導',
      wwVisual2: '學術寫作',
      wwVisual3: '寫作資源',
    },
    announcementsPage: {
      heroLead: '掌握英語增能活動、報名提醒與中心最新消息',
      hintPinned: '置頂',
      hintPinnedDesc: '重要公告會顯示在最上方',
      hintCategory: '分類',
      hintCategoryDesc: '依公告類型快速辨識',
      hintPublished: '已發布',
      hintPublishedDesc: '前台僅顯示可供查閱公告',
      badgePinned: '置頂',
      filterSearch: '搜尋',
      filterSearchPlaceholder: '標題、摘要、slug…',
      filterCategory: '分類',
      filterCategoryAll: '全部分類',
      filterTag: '標籤',
      filterTagPlaceholder: '單一標籤關鍵字',
      filterApply: '套用',
      filterReset: '重設',
      emptyDescription: '最新消息發布後會顯示在這裡。',
      copyLink: '複製連結',
      copyLinkDone: '已複製連結',
      readingMinutes: '約 {{minutes}} 分鐘閱讀',
      updatedAt: '更新',
      goBookActivity: '前往活動預約',
    },
    learningStyleModal: {
      done: '完成',
      close: '關閉',
    },
    speakingCheck: {
      title: '口說檢測',
    },
    wordBridge: {
      pageTitle: '語彙連橋：找出你的英語起點',
      pageLead: '將同主題的單字分成四詞一組，從 A1 晉級至 C2，推估你的 CEFR 參考層級並取得適合的活動建議。',
      sectionKicker: 'Self check',
      sectionTitle: '語彙連橋：找出你的英語起點',
      sectionLead: '將同主題的單字分成四詞一組，從 A1 晉級至 C2，推估你的 CEFR 參考層級並取得適合的活動建議。',
      kicker: 'Word Bridge',
      title: '語彙連橋',
      introLead: '每輪只會出現一個 CEFR 難度。請在限時內找出畫面上所有「四詞一組」的主題分類；答對的組會保留在畫面上。',
      rule1: '點選 4 個同一主題的單字，按「提交這組」。（例：四種顏色、四種動物）',
      rule2: '全場共 5 次失誤。每輪限時 40～110 秒（A1 最短、C2 最長）；答錯或逾時不會自動換題。',
      rule3: '完成當前難度全部組別即可晉級。失誤用盡時，推估為結束難度降一階（如於 B1 結束 → 推估 A2）。全場可手動換題 1 次，僅替換尚未完成的組。',
      start: '從 A1 開始挑戰',
      startChallenge: '開始挑戰',
      startLevelLegend: '選擇起點難度',
      surveyKicker: 'Quick survey',
      surveyTitle: '你的學習型態',
      surveyLead: '兩個簡短問題，協助我們在本次瀏覽中建議更適合的活動（不會儲存至系統）。',
      surveyDensityLegend: '你偏好哪種學習節奏？',
      surveyDensity: {
        high: '高密度：一次投入較長時間、討論較深入',
        balanced: '適中：依活動性質彈性參與',
        low: '低密度：短時段、輕鬆起步',
      },
      surveyFocusLegend: '你目前最想加強？',
      surveyFocus: {
        speaking: '口說與討論',
        balanced: '聽說讀寫均衡',
        writing: '寫作與書面表達',
      },
      surveyBack: '返回',
      surveyContinue: '開始挑戰',
      surveyDisclaimer: '此問卷僅用於本次建議，關閉分頁後不會保留。',
      visitExternalSite: '前往官網',
      disclaimer: '本測驗僅供自我評估，實際選課與活動參與請依學習狀況與教師建議。',
      levelKicker: 'Current level',
      passedLevels: '已通關：{{levels}}',
      levelUp: '晉級至 {{level}}！',
      timerLabel: '秒',
      timerAria: '剩餘 {{seconds}} 秒',
      groupProgress: '已完成 {{solved}} / {{total}} 組',
      playingHint: '選出同一主題的 4 個單字後，按「提交這組」。',
      mistakesAria: '剩餘 {{left}} 次機會，共 {{max}} 次',
      mistakesLeft: '剩 {{count}} 次機會',
      gridAria: '詞彙選擇區',
      shuffle: '重新排列',
      swapQuestions: '換題',
      submitGroup: '提交這組',
      roundCompleteKicker: 'Round complete',
      roundCleared: '本輪完成',
      roundEnded: '本輪結束',
      roundClearedLead: '你已完成第 {{current}} 輪（共 {{total}} 輪）。可繼續挑戰下一輪，或直接查看建議。',
      roundEndedLead: '失誤次數已用完，但你仍可依目前表現查看活動建議。',
      nextRound: '挑戰下一輪',
      viewResults: '查看建議結果',
      resultsKicker: 'Your fit',
      resultsTitle: '你的語彙程度與活動建議',
      estimatedLevel: '推估熟悉層級',
      resultsLead: '以下分別依詞彙測驗與學習偏好提供建議，可並行參考、擇一或搭配使用。',
      resultsLevelSection: '依詞彙測驗推估',
      resultsLevelLead: '依你通關的最高難度與結束時所在層級，建議適合的入門活動。',
      resultsStyleHint: '若想依學習節奏與加強方向取得建議，請回到活動總覽頁的「學習型態」。',
      resultsPreferenceSection: '依學習偏好',
      resultsPreferenceLead: '依你選擇的學習節奏與加強方向，建議較符合型態的活動。',
      bookActivity: '前往預約此活動',
      playAgain: '再玩一次',
      viewMistakeWords: '查看錯誤單字',
      mistakeWordsTitle: '本場錯誤單字',
      mistakeWordsLead: '以下為你提交錯誤組合時選到的單字（已去重），可作為複習參考。',
      mistakeWordsClose: '關閉',
      mistakeTabList: '單字列表',
      matchTitle: '配對複習',
      matchStart: '開始配對',
      matchIntroLead: '點選英文與對應中文配對。每輪最多 16 張卡（8 組）；已配對成功的單字本場不再出現，不足時會從已掌握詞中隨機複習。',
      matchEligibleHint: 'B1 以上錯誤單字達 4 組以上時，可進行配對複習。',
      matchProgress: '已掌握 {{mastered}} / {{total}} 組',
      matchRound: '第 {{round}} 輪',
      matchGridAria: '配對卡片區',
      matchReviewTag: '複習',
      matchExit: '結束配對',
      matchCompleteTitle: '本輪配對完成',
      matchCompleteLead: '已掌握 {{mastered}} / {{total}} 組錯誤單字。',
      matchPlayAgain: '再練一次',
      matchBackToList: '返回列表',
      resultSessionStats: '遊玩 {{duration}} · 錯誤 {{mistakes}} / {{max}} 次',
      shareResult: '分享結果',
      shareTitle: '語彙連橋測驗結果',
      shareText: '我在國立中山大學全英語卓越教學中心「語彙連橋」測到約 {{level}} 層級（遊玩 {{duration}}、錯誤 {{mistakes}}/{{max}}）。你也來試試！{{url}}',
      shareDone: '已開啟分享',
      shareCopied: '結果已複製到剪貼簿',
      shareFailed: '無法分享，請稍後再試',
      goCalendar: '查看活動日曆',
      levelA1: '入門常用詞',
      levelA2: '日常交流詞',
      levelB1: '學習討論詞',
      levelB2: '進階表達詞',
      levelC1: '高階學術詞',
      levelC2: '精通專業詞',
      confidence: {
        high: '辨識穩定度：高',
        medium: '辨識穩定度：中',
        low: '辨識穩定度：低（建議從建議活動的基礎場次開始）',
      },
      activityTag: {
        'english-table': 'ET',
        'english-club': 'EC',
        'international-forum': 'IF',
        'job-talk': 'JT',
        'writing-workshop': 'WW',
      },
      activityReason: {
        'english-table': '適合以課程主題切入、在短時間內開口練習。',
        'english-club': '適合增加口說頻率，熟悉討論節奏與表達自信。',
        'international-forum': '適合跨文化議題交流，練習觀點說明與延伸討論。',
        'job-talk': '適合職涯情境演練，加強面試與專業英文表達。',
        'writing-workshop': '適合想系統化練習寫作、需要輔導與寫作資源的學習者。',
      },
    },
    miniGames: {
      wordBridgeIntro: '字彙配對 · 約 8 分鐘。找出你的英語起點，這不是考試。',
      listeningLadderIntro: '聽力字彙 · 90 秒。聽英文、選中文，練反應力。',
      vocabularyDepthIntro: '詞彙深度 · 約 6 分鐘。測同義、搭配與慣用語，補足語彙連橋未測的深度。',
      vocabularySizeIntro: '詞彙量 · 約 2 分鐘。50 個英文詞自評是否認識，外推總詞彙量與 CEFR 參考。',
      speakingCheckIntro: '輸入老師公布的代碼，依序完成一組口說題。這是練習回饋，不是正式檢定。',
      wordBridgeTime: '約 8 分鐘',
      listeningLadderTime: '90 秒',
      vocabularyDepthTime: '約 6 分鐘',
      vocabularySizeTime: '約 2 分鐘',
      speakingCheckTime: '一組題',
      practiceKicker: '現在就練',
      practiceTitle: '英語小練習',
      practiceLead: '短時間互動練習，幫助你在預約活動前暖身、累積字彙與聽力反應。有分數與結果，但這不是考試。',
      guidesKicker: 'Prepare',
      guidesTitle: '活動前語言支援',
      guidesLead: '閱讀情境與應答方向，降低開口焦慮。沒有分數、沒有對錯。',
      startPractice: '開始練習',
      openGuide: '查看指南',
    },
    listeningLadder: {
      pageTitle: 'Listening Ladder｜聽力字彙階梯挑戰',
      pageLead: '聽英文單字、選正確中文，90 秒挑戰你的聽力字彙反應力。',
      kicker: 'Listening Ladder',
      title: '聽力字彙階梯',
      introLead: '系統播放英文單字，請從四個中文選項中選出正確翻譯。難度會隨你的表現逐步調整。',
      howToPlay: '怎麼玩',
      rule1: '每局 90 秒，盡可能多答題。',
      rule2: '每題開始會自動播放單字；需要時可按「重聽」再次播放。',
      rule3: '連續答對可升階（A1→A2→B1→B2→C1）；連續答錯可能降階。',
      rule4: '答錯不會大量扣分，請保持節奏繼續挑戰。',
      getReady: '準備開始',
      start: '開始 90 秒挑戰',
      volumeHint: '建議先確認音量或戴上耳機。行動裝置可能需要先點擊「測試播放」才能聽到語音。',
      testSound: '測試播放',
      timerLabel: '秒',
      timerAria: '剩餘 {{seconds}} 秒',
      currentLevel: '目前題目',
      streak: '連擊',
      highest: '本次最高',
      playWord: '播放單字',
      replay: '重聽',
      score: '分數',
      feedbackCorrect: '答對了',
      feedbackIncorrect: '正確答案是',
      speechUnsupported: '此瀏覽器不支援語音播放，請改用其他瀏覽器或裝置。',
      speechFailed: '無法播放音檔，請檢查音量或點擊播放按鈕重試。',
      loadError: '暫時無法載入題庫，請稍後再試。',
      resultsKicker: 'Round complete',
      resultsTitle: '本次挑戰結果',
      resultScore: '分數',
      resultCorrect: '答對題數',
      resultAccuracy: '正確率',
      resultHighest: '最高挑戰階層',
      resultStreak: '最佳連擊',
      resultWords: '聽過單字數',
      resultDuration: '遊戲時間',
      resultAnswerLog: '答題記錄',
      resultAnswerSelected: '你的答案：{{answer}}',
      resultAnswerExpected: '正確中文：{{answer}}',
      resultAnswerCorrect: '答對',
      resultAnswerWrong: '答錯',
      personalBest: '個人最佳：{{score}} 分（最高 {{level}} 題目）',
      cefrDisclaimer: '「最高挑戰階層」僅代表本次遊戲中曾答對的題目難度，不代表您的正式 CEFR 等級或英語能力認證結果。',
      playAgain: '再玩一次',
      wordBridgeCta: '接著玩語彙連橋',
      bookSessionCta: '去預約場次',
      phrasebookCta: '活動前看看應答指南',
      backToLearningResources: '返回學習資源',
      backToActivities: '更多學習資源',
    },
    vocabularyDepth: {
      pageTitle: '詞彙深度測驗｜Vocabulary Depth',
      pageLead: '從定義、語境到同義、搭配與慣用語，推估 A1–C1 詞彙深度參考層級（非正式認證）。',
      kicker: 'Vocabulary Depth',
      title: '詞彙深度測驗',
      introLead: '每個 CEFR 難度 6 題選擇題；需連續通過各級門檻才能晉級。答完即顯示解析，幫助你理解而不只是猜對。',
      howToPlay: '怎麼玩',
      rule1: '從 A1 開始，依序挑戰至 C1（本測驗不評 C2）。',
      rule2: '每級需答對至少 4/6 題（約 2/3）才算通過並進入下一級。',
      rule3: '某一級未通過時，推估層級為「上一個通過的級別」。',
      rule4: '結果僅供自我評估，請搭配中心活動持續練習。',
      start: '開始測驗',
      disclaimer: '本測驗僅供自我評估，實際選課與活動參與請依學習狀況與教師建議。',
      levelLabel: '目前級別',
      questionProgress: '第 {{current}} / {{total}} 題',
      feedbackCorrect: '答對了',
      feedbackIncorrect: '答錯了，請看解析',
      resultTitle: '本次詞彙深度結果',
      estimatedLevel: '推估參考層級：{{level}}',
      accuracy: '整體正確率：{{pct}}%',
      recommendedActivities: '建議搭配的中心活動',
      playAgain: '再測一次',
      listeningCta: '接著玩聽力字彙階梯',
      wordBridgeCta: '接著玩語彙連橋',
      bookActivityCta: '去預約場次',
      cefrDisclaimer: '推估層級僅反映本次測驗表現，不代表正式 CEFR 認證或英檢成績。',
    },
    vocabularySize: {
      pageTitle: '詞彙量測驗｜Vocabulary Size',
      pageLead: '50 個英文詞快速自評「是否認識」，外推你大概認識多少英文詞，並對應 A1–C2 參考層級（非正式認證）。',
      kicker: 'Vocabulary Size',
      title: '詞彙量測驗',
      introLead: '與「詞彙深度測驗」互補：本測驗測的是「認識多少詞」，不是同義、搭配或慣用語運用。',
      howToPlay: '怎麼玩',
      rule1: '共 50 個英文單字，來自 10 個詞頻帶（涵蓋最常見約 10,000 詞）。',
      rule2: '誠實自評：只有能想起意思、不需猜測時，才按「我認識」。',
      rule3: '不需選中文或定義，看到英文詞即可作答。',
      rule4: '完成後會估算總詞彙量與 CEFR 參考層級，並建議適合的中心活動。',
      start: '開始測驗',
      disclaimer: '結果為統計外推估計，僅供自我參考；請搭配深度測驗與實際活動練習。',
      wordProgress: '第 {{current}} / {{total}} 個詞',
      bandLabel: '詞頻帶 {{band}} / 10',
      prompt: '你認識這個英文單字的意思嗎？',
      know: '我認識',
      dontKnow: '不認識',
      resultTitle: '你的詞彙量估計',
      estimatedWords: '約 {{count}} 個英文詞',
      estimatedLevel: 'CEFR 參考層級：{{level}}',
      recognition: '本次自評認識率：{{pct}}%',
      wordsToNext: '距下一級約還需 {{count}} 詞（估計）',
      recommendedActivities: '建議搭配的中心活動',
      playAgain: '再測一次',
      depthCta: '接著玩詞彙深度測驗',
      wordBridgeCta: '接著玩語彙連橋',
      bookActivityCta: '去預約場次',
      cefrDisclaimer: '詞彙量與 CEFR 對照為近似估計，不代表正式認證或英檢成績。',
    },
    etTopics: {
      pageTitle: '本學期主題與題目',
      pageLead: '115-1 English Table 各週主題都列在這裡。預約還沒開放也可以先看題目、先準備。',
      thisWeek: '本週',
      today: '今天',
      backToEnglishTable: '返回 English Table',
    },
    phrasebook: {
      pageTitle: 'Activity Phrasebook｜活動英語應答指南',
      pageLead: '參加 English Table、English Club、Job Talk 等活動前，先看看這些情境可以怎麼回應。',
      kicker: 'Learning Guide',
      title: '活動英語應答指南',
      catalogIntro: '情境卡片、應答方向與 A2/B1/B2 範例句，幫助你降低開口焦慮。',
      noScoreNote: '這是活動前語言支架，不是測驗：沒有分數、沒有對錯、沒有排行榜。',
      filterLabel: '依活動類型篩選',
      tab: {
        all: '全部',
        'english-table': 'English Table',
        'english-club': 'English Club',
        'international-forum': 'International Forum',
        'job-talk': 'Job Talk',
      },
      panelKicker: 'Before you join',
      panelTitle: '活動前應答指南',
      panelLead: '以下是此活動類型最常見的情境，可先瀏覽再參加。',
      viewAll: '查看完整指南',
      quickPrepTitle: '活動前 5 分鐘',
      quickPrepLead: '建議先看這幾個情境，幫助你在活動中更自在開口。',
      backToActivities: '返回活動總覽',
    },
    events: {
      trustStatsAria: '活動數據概覽',
      statUpcoming: '即將舉行',
      statUpcomingHint: '尚未開始的場次',
      statOpenNow: '現可預約',
      statOpenNowHint: '目前開放報名中',
      statClosingSoonHint: '其中 {{count}} 場即將截止',
      statTotalSessions: '本頁場次',
      statTotalSessionsHint: '目前列表中的活動總數',
      statSiteViews: '累積瀏覽',
      statTodayViews: '今日 {{count}} 人次',
      state: {
        OPEN: '開放報名',
        CLOSING_SOON: '即將截止',
        NOT_YET_OPEN: '尚未開放',
        PAST_DEADLINE: '報名已截止',
        STARTED: '活動已開始',
        FULL: '已額滿',
        UNKNOWN: '狀態未知',
      },
      closingSoonTag: '即將截止',
      windowLabel: '預約開放：',
      reservationWindow: '{{start}} — {{end}}（活動開始前 2 小時截止）',
      opensAt: '開放時間：{{time}}',
      openUntil: '截止 {{time}}（{{countdown}}）',
      cutoffRule: '預約於活動開始前 {{hours}} 小時截止。',
      fullDetail: '名額已滿，無法再登記。請改選其他場次。',
      deadlinePassed: '已過截止時間',
      deadlineMinutesLeft: '距離截止約 {{minutes}} 分鐘',
      deadlineHoursLeft: '距離截止約 {{hours}} 小時',
      deadlineDaysLeft: '距離截止約 {{days}} 天',
    },
    booking: {
      modalTitle: '{{name}} · 預約',
      stepAria: '預約進度',
      step1: '填寫資料',
      step2: '完成問卷',
      step3Reserve: '預約完成',
      step3Waitlist: '預約完成',
      summaryAria: '活動資訊',
      sessionPanelTitle: '場次',
      detailsPanelTitle: '詳細資訊',
      labelName: '活動名稱',
      labelType: '活動類型',
      labelDate: '日期',
      labelTime: '時間',
      labelLocation: '地點',
      labelSpots: '剩餘名額',
      spotsFull: '已額滿',
      badgeWaitlist: '已額滿',
      badgeSurvey: '需填問卷',
      sectionTiming: '報名時間',
      timingOpen: '預約開放',
      timingClose: '預約截止',
      timingRule: '預約規則',
      timingCutoffNote: '（活動開始前 2 小時截止）',
      sectionNotes: '注意事項',
      note1: '114-1 學期起不再提供活動補蓋章服務，請務必準時參加。',
      note2: '取消須於活動開始前至少 2 小時完成。',
      note3: 'English Table / English Club 可能需先完成學期問卷方可預約。',
      etTopicLabel: '主題',
      etTopicSummary: '本週主題與題目',
      etTopicWeek: '第 {{week}} 週',
      etTopicHoliday: '本日為國定假日，沒有討論題目。',
      etTopicChartNote: '本題會搭配圖表。圖表在活動現場提供，可先看題目準備。',
      etTopicPassageLabel: '短文',
      etFormatConversation: '口說問答',
      etFormatChart: '圖表討論',
      etFormatPassage: '短文與圖表',
      etFormatDiscussion: '主題討論',
      etFormatHoliday: '國定假日',
      etTopicCatalogLink: '查看本學期所有主題與題目',
      formStudentId: '學號 Student ID',
      formName: '姓名 Name',
      formEmail: 'Email',
      formSectionTitle: '填寫預約資料',
      violationRemind: '提醒：',
      violationContinue: '您仍可繼續預約，但請注意遵守活動規範。',
      fullNoWaitlist: '此活動已額滿，無法再登記。請改選其他仍有名額的場次。',
      surveyStepMsg: '此預約需要完成問卷後才能完成。系統將引導你完成問卷，完成後會自動恢復原流程。',
      surveyStepInfo: '此活動需先完成問卷。系統即將帶你前往問卷頁，完成後會自動恢復並完成原預約流程。',
      btnCancel: '取消',
      btnReserve: 'Reserve / 預約',
      btnWaitlist: '已額滿',
      btnProcessing: '處理中...',
      btnBack: '返回',
      btnSurveyPending: '前往問卷中...',
      btnClose: '關閉',
      blacklistTitle: '無法預約 - 黑名單限制',
      blacklistHeading: '您目前被列入黑名單',
      blacklistBody: '根據系統記錄，您目前有 {{count}} 次違規紀錄，已被列入黑名單。',
      blacklistUntil: '黑名單解除時間：',
      blacklistViolationsTitle: '違規行為說明：',
      blacklistViolation1: '成功預約但未到場',
      blacklistViolation2: '活動中無正當理由中途離席',
      blacklistViolation3: '活動開始後 5 分鐘才抵達現場',
      blacklistViolation4: '其他違反活動規範的行為',
      blacklistRulesTitle: '規範說明：',
      blacklistRulesBody: '同一學期內，若同學累積兩次違規紀錄，將被列入黑名單兩週。在此期間內，您將無法預約任何活動。',
      blacklistAck: '我知道了',
      mobileContinue: '繼續填寫資料',
      mobileBackSession: '返回場次',
      mobileSessionStep: '確認場次',
    },
    // 常見問題 FAQ
    faq: {
      title: '常見問題 FAQ',
      cancel: '如何取消預約',
      blacklist: '黑名單怎麼辦',
      rules: '英語增能活動規定',
      // 取消預約
      cancelQuestion: '如何取消預約？',
      cancelSteps: '取消預約步驟：',
      cancelStep1: '點擊頁面上的「查詢預約紀錄」按鈕',
      cancelStep2: '輸入您的姓名、學號和電子信箱',
      cancelStep3: '系統會顯示您的預約紀錄',
      cancelStep4: '找到要取消的活動，點擊「刪除」按鈕',
      cancelStep5: '確認刪除後，預約即被取消',
      importantReminder: '重要提醒',
      cancelRemind1: '活動開始前 2 小時內不可取消預約',
      cancelRemind2: '若無法參加活動，請務必在活動開始前 2 小時完成取消',
      cancelRemind3: '未取消且未到場將被視為違規，累積兩次違規將被列入黑名單',
      cancelRemind4: '如需協助，請聯繫 EMI 中心',
      // 黑名單
      blacklistQuestion: '被列入黑名單怎麼辦？',
      blacklistMechanism: '黑名單機制說明：',
      blacklistRule: '同一學期內，若同學累積兩次違規紀錄，將被列入黑名單兩週。',
      violationsInclude: '違規行為包括：',
      violation1: '成功預約但未到場：預約了活動但沒有參加',
      violation2: '活動中無正當理由中途離席：參加活動後未經允許提前離開',
      violation3: '遲到超過 5 分鐘：參加各項英語增能活動者，如於活動開始後 5 分鐘才抵達現場，亦視同違規',
      blacklistImpact: '黑名單期間的影響',
      impact1: '黑名單期間為兩週（14 天）',
      impact2: '期間內無法預約任何活動',
      impact3: '黑名單期滿後，違規紀錄會重置，可重新開始預約',
      impact4: '請務必遵守活動規定，避免被列入黑名單',
      howToAvoid: '如何避免被列入黑名單？',
      avoid1: '預約前確認可以參加活動',
      avoid2: '若無法參加，務必在活動開始前 2 小時取消預約',
      avoid3: '準時參加活動，避免遲到超過 5 分鐘',
      avoid4: '活動進行中不要無故中途離席',
      avoid5: '如有特殊情況，請提前聯繫 EMI 中心',
      // 規定
      rulesTitle: '英語增能活動規定',
      rulesImportant: '重要規定：',
      ruleNoOnsite: '不接受現場預約：所有活動必須提前完成線上預約',
      ruleNoStampService: '不提供補蓋章：114-1學期起不再提供活動補蓋章服務',
      ruleNoLate5: '不接受遲到五分鐘後入場：活動開始後 5 分鐘才抵達視同違規',
      ruleNoOnsiteDetail: '不接受現場預約',
      ruleNoOnsiteD1: '所有英語增能活動僅接受線上預約',
      ruleNoOnsiteD2: '活動不開放候補（含現場與線上），請務必提前完成預約',
      ruleNoOnsiteD3: '請在活動開放預約時間內完成預約，避免錯過機會',
      ruleNoOnsiteD4: '若活動已額滿，請改選其他場次或等待下次活動開放預約',
      ruleNoStampDetail: '不提供補蓋章服務',
      ruleNoStampD1: '114-1學期起不再提供活動補蓋章服務',
      ruleNoStampD2: '請同學們務必準時參加活動，完成活動才能獲得蓋章',
      ruleNoStampD3: '若因個人因素無法參加，請提前取消預約，讓其他同學有機會參與',
      ruleNoStampD4: '錯過活動將無法補蓋章，請謹慎規劃時間',
      ruleLateDetail: '不接受遲到五分鐘後入場',
      ruleLateD1: '參加各項英語增能活動者，如於活動開始後 5 分鐘才抵達現場，亦視同違規',
      ruleLateD2: '請務必在活動開始前抵達並完成報到',
      ruleLateD3: '建議提前 5-10 分鐘到達，避免因交通或其他因素遲到',
      ruleLateD4: '遲到超過 5 分鐘將無法入場，且會被記錄為違規',
      ruleLateD5: '累積兩次違規將被列入黑名單兩週',
      otherRules: '其他重要規定',
      otherR1: '活動開始前 2 小時內不可取消預約',
      otherR2: '活動全程使用英語進行，請做好準備',
      otherR3: '活動中請勿無故中途離席',
      otherR4: '請尊重講師和其他參與者',
      otherR5: '遵守活動場地的相關規定',
      bookingWindowTitle: '何時開始報名',
      bookingWindowEt: 'English Table／自訂類型：活動日前一天 12:00',
      bookingWindowJt: 'Job Talk：活動開始前 7 天同一星期幾 12:00',
      bookingWindowEc: 'English Club：上週三 12:00',
      bookingWindowIf: 'International Forum：上週五 12:00',
      bookingWindowCutoff: '全部活動：活動開始前 2 小時截止預約與取消',
      englishVersion: 'English Version',
    },
    elpPage: {
      heroTitle: '英語實踐歷程護照',
      heroDesc: '透過完成指定英語學習任務累積點數，滿 100 點即可完成英語文能力標準認證。',
      guideKicker: '學生使用說明',
      guideTitle: '英語實踐歷程檔案快速指南',
      guideDesc: '先完成信箱驗證並申請護照，即可提交任務附件累積點數；滿 100 點後系統自動完成認證，可匯出認證單。',
      guideOpenLarge: '開啟大圖',
      guideImageUrl: '',
      guideImageAlt: 'EEARS 英語實踐歷程檔案學生使用說明，包含申請護照、等待核准、完成任務並上傳、查看累積點數、滿 100 點完成認證等流程',
      identifyTitle: '身分驗證',
      identifySubmit: '進入我的護照',
      emailHint: '須為中山大學校內信箱（@student / @g-mail / @mail / @faculty.nsysu.edu.tw）',
      applyLead: '尚未申請護照。請先完成信箱驗證後送出申請，通過後即可立即提交點數項目（無需行政再核准護照）。',
      applyButton: '申請護照',
      completedMessage: '已累積達標並完成英語能力標準認證（點數審核通過後自動完成，無需再送最終申請）。',
      exportCertificate: '匯出認證單（PDF）',
      submitSectionTitle: '可提交項目',
      submitAction: '提交紀錄',
    },
    // 新首頁 Landing（homePage.*）
    homePage: {
      heroEyebrow: '國立中山大學 EMI 全英語卓越教學中心',
      heroTitle: '英語增能活動預約系統',
      heroTagline: 'English Enhancement Activity Reservation System',
      heroDescClassic: '整合英語桌、英語社群、講座等學習資源，提供學生快速報名與預約管道。',
      heroSubtitle: 'English Enhancement Activity Reservation System',
      heroDesc: '提供活動瀏覽、線上預約、預約查詢與取消，以及培力英檢報名等服務。',
      heroServices: 'English Table、English Club、International Forum 活動預約；培力英檢與學習有伴團體報名；學期問卷填寫。',
      heroCtaBrowse: '瀏覽活動',
      heroCtaMyReservations: '查詢我的預約',
      heroCtaBestep: '培力英檢報名',
      heroSecondaryNavAria: '其他常用連結',
      heroServicesAria: '系統提供的服務項目',
      heroBentoBestepDesc: '個人與團體培力英檢報名',
      heroBentoCalendarDesc: '以日曆檢視各類活動場次',
      heroCtaBook: '立即預約活動',
      heroCtaGroupAria: '首頁主要行動按鈕',
      bentoSectionAria: '首頁主要功能入口',
      heroCtaActivities: '查看活動',
      quickActionsTitle: '快速入口',
      quickPanelTitle: '學生常用任務',
      quickBook: '立即預約活動',
      quickBookDesc: '選擇活動並完成預約',
      quickBookTag: '主要入口',
      quickMyReservation: '查詢／取消我的預約',
      quickMyReservationDesc: '登入後查詢或取消已預約的活動',
      quickSurvey: '本學期問卷',
      quickSurveyDesc: '填寫學期問卷以開放預約',
      quickSurveyDescIdle: '目前沒有必填問卷；若 ET／EC 需要填寫，預約時會再提醒',
      quickRules: '活動規則／違規說明',
      quickRulesDesc: '了解預約與違規規定',
      quickPassport: '英語實踐歷程護照',
      quickPassportDesc: '累積學習點數，申請英語能力認證',
      quickPractice: '現在就練 5 分鐘',
      quickPracticeDesc: '字彙配對或 90 秒聽力，先熱身再開口',
      practiceNowKicker: '5 分鐘練習',
      practiceNowTitle: '現在就練',
      practiceNowLead: '沒有場次也能先暖身。字彙配對約 8 分鐘，聽力挑戰 90 秒。',
      practiceNowCtaMore: '看全部練習與網站',
      coreTasksKicker: 'Student desk',
      coreTasksTitle: '核心任務入口',
      coreTasksLead: '把學生最常需要完成的預約、查詢、英檢與實踐歷程放在前面，進站後可以直接開始辦事。',
      coreTasksSecondaryCta: '查詢我的預約',
      taskBookTitle: '預約近期活動',
      taskBookDesc: '查看 English Table、English Club 與中心活動場次，確認名額後完成預約。',
      taskBookCta: '前往活動',
      taskReservationsTitle: '查詢或取消預約',
      taskReservationsDesc: '登入後查看已預約場次，並在截止時間內用驗證碼取消。',
      taskReservationsCta: '管理預約',
      taskPassportTitle: '申請實踐歷程',
      taskPassportDesc: '上傳英語學習紀錄，累積點數並追蹤審核狀態。',
      taskPassportCta: '開啟護照',
      taskBestepTitle: '英檢報名',
      taskBestepDesc: '進入培力英檢報名流程，確認個人或團體報名需求。',
      taskBestepCta: '開始報名',
      activitiesTitle: '近期可預約活動',
      activitiesKicker: 'Open sessions',
      activitiesLead: '從活動類型進入近期場次，確認開放時間、剩餘名額與預約規則。',
      viewAllActivities: '查看全部活動',
      activityReserve: '立即預約',
      activityLearnMore: '了解更多',
      stepsTitle: '使用流程',
      stepsKicker: 'How it works',
      step1: '選擇想參加的活動',
      step2: '確認學籍與個人資料',
      step3: '提交預約／完成報名',
      step4: '準時參與並累積學習紀錄',
      announcementsTitle: '最新公告',
      announcementsKicker: 'Updates',
      announcementsLead: '活動異動、報名提醒與中心消息。',
      studentServicesKicker: 'Student services',
      studentServicesTitle: '學生常用功能',
      studentServicesLead: '這些入口不一定每天使用，但通常和預約資格、學習紀錄或行政提醒有關。',
      serviceSurveyMeta: 'Survey',
      serviceSurveyTitle: '本學期問卷',
      serviceSurveyDesc: '完成必要問卷，避免影響 English Table 或 English Club 預約資格。',
      servicePartnerMeta: 'Partner',
      servicePartnerTitle: '學習有伴',
      servicePartnerDesc: '進入團體英檢報名與小隊相關流程，查詢後續狀態。',
      serviceRulesMeta: 'Rules',
      serviceRulesTitle: '預約與違規規定',
      serviceRulesDesc: '確認取消期限、遲到、未到場與黑名單規則。',
      serviceNewsMeta: 'News',
      serviceNewsTitle: '全部公告',
      serviceNewsDesc: '查看中心公告、活動異動、報名通知與行政提醒。',
      pinnedBadge: '置頂',
      viewAllAnnouncements: '查看全部公告',
      readMore: '閱讀更多',
      noAnnouncements: '目前尚無最新公告',
      announcementsEmptyBack: '返回主要功能',
      announcementsEmptyActivities: '查看活動',
      announcementsError: '公告暫時無法載入',
      announcementNotFound: '找不到該則公告或尚未發布',
      backToAnnouncementsList: '返回公告列表',
      faqTitle: '常見問題',
      faqKicker: 'FAQ',
      faq1Q: '我要怎麼預約活動？',
      faq1A: '點選「立即預約活動」進入日曆頁，選擇開放預約中的場次。預約前請先登入學生帳號，系統會使用你的學號、姓名與信箱。送出後請確認系統提示與信箱通知，活動當天依公告時間到場。',
      faq2Q: '我還不確定要參加哪一種活動，該怎麼選？',
      faq2A: '可以先到「活動介紹」查看各活動差異。想練課堂主題可選 English Table；想增加口說練習可選 English Club；想和國際學生交流可選 International Forum；想準備面試或職場英文可選 Job Talk。',
      faq3Q: '無法出席時可以取消預約嗎？',
      faq3A: '可以。請在該活動的取消截止時間前登入，到「查詢／取消我的預約」，用預約信裡的驗證碼取消。截止時間依活動類型而定。若未取消且未到場，會被記為違規。',
      faq4Q: '為什麼有些活動需要先完成問卷？',
      faq4A: '部分 English Table 或 English Club 場次會要求先完成本學期問卷，中心會用問卷確認學生背景與活動需求。若系統提示需填問卷，請先完成後再回到日曆預約。',
      faq5Q: '活動額滿時還能預約嗎？',
      faq5A: '額滿後無法再登記，系統不開放候補。請改選其他同類型場次，或留意最新公告與日曆是否新增場次。',
      faq6Q: '違規紀錄會怎麼計算？',
      faq6A: '常見違規包含成功預約但未到場、遲到超過規定時間、活動中無故離席等。同一學期累積兩次違規會被列入黑名單兩週，期間無法預約活動。',
      faq7Q: '參加活動後會有學習紀錄或證明嗎？',
      faq7A: '活動完成後的紀錄會依中心規則處理。若要申請英語實踐歷程或能力認證，請到「英語實踐歷程護照」查看可申請項目、上傳資料與審核狀態。',
      faq8Q: '培力英檢報名和活動預約是同一件事嗎？',
      faq8A: '不是。活動預約主要用於 English Table、English Club、International Forum、Job Talk 等活動；培力英檢報名是另一個流程，請從「培力英檢報名」入口進入。',
      faq9Q: '各類活動什麼時候開始報名？',
      faq9A: 'English Table 與自訂類型為活動日前一天 12:00；Job Talk 為開始前 7 天同一星期幾 12:00；English Club 為上週三 12:00；International Forum 為上週五 12:00。全部活動均於開始前 2 小時截止預約與取消。各場次實際時間以日曆顯示為準。',
      contactTitle: '聯絡資訊',
      contactKicker: 'Contact',
      contactLead: '如需協助預約、報名或帳務相關問題，請透過下列方式聯繫中心。',
      contactPageLink: '在關於我們查看聯絡資訊',
      contactAddress: '地址',
      contactAddressValue: '高雄市鼓山區蓮海路70號，圖資大樓10樓西灣學院',
      contactPhone: '電話',
      contactPhoneValue: '07-5252000 # 5808/5876',
      contactEmail: 'Email',
      contactEmailValue: 'emicenter@mail.nsysu.edu.tw',
      contactHours: '服務時間',
      contactHoursValue: 'Mon–Fri 09:00–17:00',
      contactUs: '聯絡我們',
      goToCenter: '前往中心官網',
      footerHome: '首頁',
      footerAnnouncements: '最新公告',
      footerActivities: '活動介紹',
      footerLearningResources: '學習資源',
      footerCourseGuide: '修課說明',
      footerRegulationsForms: '法規表單',
      footerAbout: '關於我們',
      footerEvents: '預約場次',
      footerMyReservations: '我的預約',
      footerProgress: '我的英語進度',
      footerFaq: 'FAQ',
      footerContact: '聯絡資訊',
      footerPrivacy: '隱私權政策',
      footerTerms: '使用條款',
      footerAdmin: '管理員入口',
    },
    learningResourcesPage: {
      title: '學習資源',
      lead: '練習遊戲、口說指南與相關學習素材，幫助你在活動前後持續累積英語能力。',
      sitesKicker: '外部網站',
      sitesTitle: '學習網站',
      sitesLead: '每個網站用途不同：聽力、測驗、閱讀或說寫檢測。點卡片會開新分頁。',
      sitesTag: 'Website',
      sitesCardLead: '外部學習平台',
      sitesLiveAbc: '聽力與生活英語影音教材',
      sitesEasyTest: '校內線上測驗與練習',
      sitesWalkingLibrary: '圖書館電子資源與閱讀',
      sitesCoolEnglish: '教育部英語學習平台（聽說讀寫）',
      sitesTeemi: '英語文說寫能力檢測',
      openWebsite: '前往網站',
    },
    regulationsFormsPage: {
      title: '法規表單',
      lead: '彙整英語能力規範、認定辦法、獎勵要點與申請表單，方便直接查閱或下載。',
      note: '以下檔案依主題與語言分區整理，點擊卡片會以新分頁開啟 PDF 或表單檔案。',
      faqTitle: '常見問題',
      faqDesc: '預約、取消、違規與黑名單等常見問題說明。',
      privacyDesc: '個人資料蒐集、使用與保護說明。',
      termsDesc: '系統使用規範與服務條款。',
      openLink: '前往查看',
      openFile: '開啟檔案',
      fileCount: '{{count}} 份文件',
      statsSummary: '{{sections}} 個分類 · {{files}} 份文件',
      expandAll: '全部展開',
      collapseAll: '全部收合',
      enrollYearLabel: '我的入學年：',
      enrollYearPlaceholder: '如 113',
      enrollYearTag: '{{year}} 學年度',
      enrollYearHint: '輸入三碼學年度後，只顯示適用該年的法規與表單',
    },
    aboutPage: {
      heroEyebrow: '國立中山大學西灣學院',
      heroTitle: '全英語卓越教學中心',
      heroLead: '推動全英語教學與英語增能活動，營造知學並用、充滿活力的學習環境。',
      heroLocation: '圖資大樓 10 樓西灣學院 · 高雄市鼓山區蓮海路 70 號',
      scrollHint: '往下探索',
      heroJourneyHint: '往下滾動，走進一趟從入學到畢業的英語學習旅程。',
      progressAria: '關於我們頁面進度',
      progressIntro: '開場',
      progressStory: '旅程',
      progressActivities: '活動',
      progressTeam: '團隊',
      progressCta: '開始',
      missionKicker: 'About the Center',
      missionTitle: '我們的故事與使命',
      missionStepsAria: '中心介紹章節',
      missionStep1: '源由',
      missionStep2: '核心價值',
      missionStep3: '宗旨',
      missionStep4: '教學目標',
      journeyStep5: '服務',
      journeyStep6: '畢業',
      journeyGraduateTitle: '把英語變成你的日常能力',
      journeyGraduateBody:
        '從入學、課堂、活動到學習歷程，中心陪你走到畢業。接下來選擇適合的英語增能活動，開始你的下一站。',
      originTitle: '因雙語教育而生',
      originBody:
        '國立中山大學為響應、支持政府積極推動雙語教育政策，培育優秀的雙語人才，於 110 學年度第一學期正式成立西灣學院全英語卓越教學中心，整合校內全英語教學與英語增能相關資源。',
      valuesTitle: '我們相信什麼',
      valuesBody:
        '運用本校獨特的環境與堅強的行政組織，整合優秀的教學團隊，開創生動活潑的教材教法，激發學習的信心與興趣。',
      purposeTitle: '我們要做什麼',
      purposeBody:
        '提供學生優質的通識教育學習經驗，支持教師實現卓越創新的教學，協助教師達到既定教學目標，並加強校內各單位的合作夥伴關係，營造充滿活力、知學並用的學習環境。',
      goalsTitle: '我們的方向',
      goal1: '建立自然、多元、具有包容性的全英語教學和學習環境。',
      goal2: '加強學生學術知能與素養，提升其英語能力及溝通技巧。',
      goal3: '協助教師精進教學，促進教師之間教學理念、創新、策略和資源的共享。',
      goal4: '建立具有彈性、知識性，並能蓬勃發展的師生社群及師生知能交流平台。',
      platformKicker: 'Digital services',
      platformTitle: '線上預約與學習服務',
      platformBody:
        '本網站為中心官方網站，整合英語增能活動預約、培力英檢報名、學習歷程與學期問卷等服務，讓學生在一站完成常用任務。',
      platformBookDesc: '瀏覽場次、線上預約、查詢或取消預約。',
      platformBestepDesc: '個人與團體培力英檢報名與相關流程。',
      platformPassportDesc: '累積英語學習紀錄，申請能力認證。',
      activitiesKicker: 'English Enhancement',
      activitiesTitle: '英語增能活動',
      activitiesLead: '從課堂延伸、口說練習到國際交流與職場英文，依學習需求選擇適合的活動。',
      activityCta: '了解此活動',
      ctaTitle: '準備好開始了嗎？',
      ctaLead: '瀏覽近期場次完成預約，或聯絡中心取得協助。',
      ctaBook: '立即預約活動',
      ctaContact: '聯絡我們',
      centerIntro:
        '國立中山大學西灣學院全英語卓越教學中心（EMI Center）致力推動全英語教學與英語增能活動，整合英語桌、英語社群、國際論壇等學習資源，提供學生參與與成長的管道。',
      eearsIntro:
        '本網站整合英語增能活動預約、培力英檢報名、學習歷程與學期問卷等服務；學生可瀏覽活動、線上預約、查詢或取消預約，並完成必要問卷。',
      facultyTitle: '師資介紹',
      facultyLead: '英語增能活動與課程之師資團隊',
      adminTitle: '行政團隊',
      adminLead: '中心行政與專案支援',
      phoneExt: '分機',
      sourceTeam: '完整師資介紹',
      sourceAdmin: '完整行政團隊',
      viewOnCenterSite: '了解更多',
    },
    privacyPage: {
      title: '隱私權政策',
      lastUpdated: '最後更新：2026年3月',
      intro: '國立中山大學 EMI 全英語卓越教學中心（以下稱本中心）英語增能活動預約系統（EEARS）尊重並保護您的個人資料。本政策說明我們如何蒐集、使用、儲存及保護您的資訊。',
      section1Title: '一、蒐集之資料',
      section1Body: '為提供預約、查詢與取消等服務，我們會蒐集您主動填寫的姓名、學號、電子信箱等必要資料，以及系統自動記錄之瀏覽人次等非個人化統計資料。',
      section2Title: '二、使用目的',
      section2Body: '您的資料僅用於：活動預約與通知、預約查詢與取消、違規與黑名單管理、系統維運與統計分析，以及法律規定之情形。我們不會將您的個人資料用於上述目的以外之用途。',
      section3Title: '三、資料保存與安全',
      section3Body: '我們依業務需求與相關法規保存資料，並採取適當之技術與管理措施保護資料安全，防止未經授權之存取、竄改或洩漏。',
      section4Title: '四、資料之提供與權利',
      section4Body: '您得依個人資料保護法行使查詢、閱覽、製給複本、補充、更正、停止蒐集／處理／利用或刪除等權利；如有需求請聯繫本中心。若您不提供必要資料，可能無法使用預約等相關服務。',
      section5Title: '五、政策修訂',
      section5Body: '本政策可能因法規或服務調整而修訂，修訂後將於本頁公告；若修訂涉及重大權益，我們將以適當方式通知您。',
    },
    termsPage: {
      title: '使用條款',
      lastUpdated: '最後更新：2026年3月',
      intro: '使用國立中山大學 EMI 全英語卓越教學中心英語增能活動預約系統（EEARS）即表示您同意遵守以下使用條款。請務必詳閱。',
      section1Title: '一、服務說明',
      section1Body: '本系統提供英語增能活動（如 English Table、English Club、International Forum 等）之線上預約、查詢與取消服務，服務對象以本校學生及本中心公告之對象為限。',
      section2Title: '二、使用者義務',
      section2Body: '您應提供正確、完整之個人資料；不得冒用他人身分。預約後若無法參加，應於活動開始前至少 2 小時完成取消。未取消且未到場、遲到逾規定時間或無故中途離席等，將依本中心規定記為違規，累積達一定次數將受黑名單等處置。',
      section3Title: '三、違規與黑名單',
      section3Body: '同一學期內累積兩次違規者，將被列入黑名單兩週，期間無法使用預約功能。違規定義包括：成功預約但未到場、活動中無正當理由中途離席、活動開始後逾規定時間才抵達等，詳細以本中心公告為準。',
      section4Title: '四、智慧財產與使用限制',
      section4Body: '本系統之程式、介面、內容及標誌等，除另有標示外，屬本中心或國立中山大學所有。您僅得於符合本條款及本中心規定之範圍內使用本系統，不得進行逆向工程、大量抓取、干擾服務或侵害他人權益之行為。',
      section5Title: '五、免責與條款變更',
      section5Body: '本系統依現狀提供，若因不可抗力、維修或網路等因素導致服務中斷或資料遺失，本中心將盡力排除但不負賠償責任。本中心保留修訂本條款之權利，修訂後將於本頁公告，繼續使用即視為同意修訂內容。',
    },
    page: {
      myReservationsTitle: '我的預約查詢',
      myReservationsLead: '這裡顯示你登入帳號的預約。取消時仍要輸入預約信裡的驗證碼。',
      activitiesLead: '先看懂各類活動在做什麼、適合誰、通常怎麼進行，再前往日曆選擇近期開放場次。',
      activityCategoryLead: '此類型活動的日曆與預約入口。',
      calendarBookingTitle: '日曆預約',
      etTopicsCta: '本學期主題與題目',
      calendarBookingLead: '依日曆選擇場次，直接預約或查詢／取消預約。',
      comingSoon: '敬請期待',
      bestepLabel: 'BESTEP',
      bestepComingSoon: 'BESTEP 活動籌備中，敬請期待。',
      calendarCtaToActivities: '先了解活動類型 → 活動介紹',
      eventTypeFilterAll: '全部場次',
      calendarInsightsAria: '日曆場次摘要與狀態說明',
      calendarSummaryBookable: '可預約 {{count}} 場',
      calendarSummaryTotal: '共 {{count}} 場',
      calendarJumpNext: '跳到最近可預約',
      calendarJumpNearest: '查看最近場次',
      calendarJumpNone: '目前沒有可預約場次',
      calendarNoBookableHint: '目前沒有可預約場次，仍可查看已公告場次。',
      calendarListNoEventsInRange: '這個日期範圍內沒有場次',
      calendarLegendTitle: '狀態',
      calendarLegendFull: '已額滿',
      calendarLegendClosed: '尚未開放／已截止',
      reservationLookupTitle: '查詢預約紀錄',
      reservationStudentId: '學號 (Student ID)',
      reservationName: '姓名 (Name)',
      reservationEmail: 'Email',
      reservationSearch: '搜尋',
      reservationClose: '關閉',
      reservationNoRecords: '查無相應的預約紀錄',
      reservationEvent: '活動名稱 (Event)',
      reservationDate: '日期 (Date)',
      reservationTime: '時間 (Time)',
      reservationCancel: '取消 (Cancel)',
      reservationCancelBtn: '取消預約 (Cancel Reservation)',
      reservationVerifyCode: '驗證碼 (Verification Code)',
      reservationVerifyPlaceholder: '請輸入驗證碼',
      reservationVerifyHint: '請輸入預約成功郵件中的驗證碼',
      reservationConfirmCancel: '確認取消 (Confirm Cancel)',
      reservationCancelBack: '取消 (Cancel)',
      reservationCannotCancel: '無法取消 (Cannot Cancel)',
      reservationCancelDeadline: '取消截止時間',
      reservationSearchHint: '查詢使用你的登入身分。',
      surveyEmptyTitle: '目前沒有開放中的問卷',
      surveyEmptyDesc: '這不代表你不能預約活動。若系統在預約時提示需填問卷，請依提示完成後再回來預約。',
      surveyEmptyCtaEvents: '查看本週場次',
      surveyEmptyCtaActivities: '了解活動類型',
      courseGuideStatusTitle: '這頁是畢業規定說明，不是你的個人成績',
      courseGuideStatusLead: '若要查自己的預約、護照點數與認證進度，請到「我的英語進度」。培力英檢報名是另一個流程，不等於畢業英語認證。',
      courseGuideStatusCtaProgress: '查看我的英語進度',
      courseGuideStatusCtaPassport: '英語實踐歷程護照',
      courseGuideStatusCtaBestepNote: '培力英檢報名',
      courseGuideStatusBestepHint: '（選考／培力方案，非畢業認證本身）',
      studentProgressTitle: '我的英語進度',
      studentProgressLead: '登入後查看你的活動參與、修課、考試與護照摘要（資料以本系統匯入為準）。',
      studentProgressEmptyTitle: '目前還沒有學習紀錄',
      studentProgressNotFound: '這個帳號目前沒有活動、修課或考試紀錄。之後完成的預約與匯入資料會出現在這裡。',
      studentProgressLoadError: '無法載入進度資料，請稍後再試。',
      studentProgressTotal: '總預約：',
      studentProgressNextUpcoming: '下一場即將開始',
      studentProgressRecentActivities: '最近 3 場活動',
      studentProgressNoUpcoming: '目前沒有即將到來的預約場次。',
      studentProgressNoRecent: '尚無已結束的活動紀錄。',
      studentProgressAttendedBadge: '已出席',
      studentProgressNoShowBadge: '未到／違規',
      studentProgressUpcomingBadge: '即將到來',
      studentProgressPendingBadge: '待確認',
      studentProgressCourses: '修課紀錄（匯入）',
      studentProgressExams: '考試紀錄（匯入／報名）',
      studentProgressEnglishTestRegs: '培力英檢報名',
      studentProgressBestepScores: 'BESTEP 成績',
      studentProgressBestepAttendance: 'BESTEP 出席',
      studentProgressBestepAttended: '已出席',
      studentProgressBestepAbsent: '缺席',
      studentProgressTotalScore: '總分',
      studentProgressReservations: '活動預約',
      studentProgressReservationsCount: '共 {{count}} 筆紀錄',
      studentProgressReservationsEmpty: '目前查無預約紀錄',
      studentProgressElpPoints: '護照累積點數',
      studentProgressElpEmpty: '尚未申請或未建立護照',
      studentProgressElpApply: '前往英語實踐歷程護照',
      studentProgressElpOptionalLink: '了解護照替代認證路徑',
      studentProgressAttended: '已出席：',
      studentProgressNoShow: '未到：',
      studentProgressUpcoming: '即將到來：',
      studentProgressCertPath: '認證路徑',
      studentProgressCertStepCourse: '英語課程',
      studentProgressCertStepTest: '英檢成績',
      studentProgressCertStepPassport: '護照 100 點',
      studentProgressCertHint: '畢業英語認證可透過英檢成績或護照 100 點；詳見修課說明。',
      studentProgressCertCta: '修課與認證說明',
      homeOverlayClose: '略過動畫，直接使用',
      eventsStickyMyReservations: '查我的預約',
      eventsStickyHint: '已預約？請用單一入口登入後再查詢或取消（截止時間依活動類型而定）',
      reservationResultNextHint: '取消請在該活動的截止時間前完成，時間依活動類型而定。還想再約一場也可以。',
      reservationResultBookAnother: '再預約一場',
      reservationResultProgress: '查看我的英語進度',
      englishTestNotGraduation: '這是培力英檢報名，不是查畢業英語認證。',
      englishTestOfficialAnnouncementLink: '前往西灣學院完整公告（新分頁）',
      englishTestOfficialAnnouncementHint: '完整規定、獎勵金與注意事項以官方網頁為準，建議開啟閱讀後再繼續報名。',
      englishTestAnnouncementNextHint: '請勾選已閱讀報名須知後，才能繼續下一步。',
      englishTestAnnouncementNext: '下一步 →',
      englishTestPrivacyNextHint: '請勾選同意個資使用後，才能繼續下一步。',
      englishTestProgressLink: '查看我的英語進度',
      englishTestCourseGuideLink: '修課與認證說明',
      reservationResultTitle: '查詢結果',
      reservationBadgeCancelable: '可取消',
      reservationBadgeLocked: '已鎖定取消',
      reservationBadgeCanceling: '取消確認中',
      reservationCardStatusAria: '預約狀態',
      eventTypeFilterGroupAria: '活動分類',
      eventTypeFilterCurrentSuffix: '（目前選取）',
    },
    weekly: {
      title: '英語中心週報',
      kicker: 'EEARS Weekly',
      pageLead: '每週消息、學習提示與語彙挑戰。',
      issueLabel: '第 {{issue}} 期',
      defaultHeadline: '歡迎閱讀本週英語中心週報。',
      tipLabel: '學習一點',
      editorialTitle: '本週編輯台',
      readFull: '閱讀完整週報',
      later: '稍後再看',
      loadError: '週報暫時無法載入，請稍後再試。',
      empty: '目前尚無已發布的週報。',
      bookCta: '前往活動預約',
      activitiesCta: '瀏覽活動總覽',
      challengeTitle: '本週語彙挑戰',
      challengeKicker: 'Weekly challenge',
      challengeIntro: '將 16 個詞彙分成 4 組語意相關的詞。選取 4 個詞後送出；錯誤 5 次或時間到則結束。',
      challengeStart: '開始挑戰',
      challengeWon: '恭喜完成本週挑戰！',
      challengeLost: '本週挑戰結束，歡迎再試一次。',
      challengeStats: '共使用 {{mistakes}} 次機會',
      challengeRetry: '再玩一次',
      challengeBook: '預約活動',
      challengeUnavailable: '本週語彙挑戰尚未設定。',
      challengeGridAria: '語彙挑戰詞彙格',
      archiveTitle: '過往期數',
      previewTitle: '週報預覽',
      previewBanner: '此為預覽頁面，內容可能尚未發布。',
      previewError: '預覽連結無效或已過期。',
      previewDraft: '草稿',
      pollLoading: '載入投票…',
      pollLoadError: '無法載入投票',
      pollVoteError: '投票失敗',
      pollSubmit: '送出投票',
      pollSubmitting: '送出中…',
      pollThanks: '感謝參與！',
      pollTotalVotes: '共 {{count}} 票',
      quizFillPlaceholder: '請輸入答案',
      quizSubmit: '提交答案',
      quizSubmitting: '提交中…',
      quizSubmitError: '提交失敗',
      quizCorrect: '答對了',
      quizWrong: '再想想看',
      quizScore: '得分：{{correct}} / {{total}}',
      shareResult: '分享成績',
      shareCopied: '已複製分享文字',
      readComplete: '已讀',
    },
  },
  en: {
    a11y: {
      skipToContent: 'Skip to main content',
      openMenu: 'Open menu',
      closeMenu: 'Close menu',
      mainNavigation: 'Main navigation',
    },
    nav: {
      home: 'Home',
      eventsBooking: 'Book Sessions',
      myReservations: 'My Reservations',
      activities: 'Activities',
      activitiesIntro: 'Activity Intro',
      announcements: 'Announcements',
      learningResources: 'Learning Resources',
      courseGuide: 'Course Guide',
      regulationsForms: 'Regulations & Forms',
      faq: 'FAQ',
      about: 'About',
      contact: 'Contact',
      englishTest: 'BESTEP (Exam Registration)',
      englishTestEdit: 'BESTEP (Data Correction)',
      englishLearningPassport: 'English Learning Passport',
      myProgress: 'My Progress',
      myRecord: 'My record',
      speakingPortfolio: 'Speaking portfolio',
      classCreditAllocation: 'Class credit allocation',
      groupTask: 'Take Action',
      groupExplore: 'Explore',
      login: 'Login',
      studentLogin: 'Log in',
      studentAccount: 'My account',
      backToStudentAccount: 'Back to my account',
      studentLogout: 'Log out',
      adminEntry: 'Admin Login',
    },
    footer: {
      centerName: 'EMI English Enhancement Teaching Resource Center',
      centerNameShort: 'EMI Center',
      contact: 'Contact Us',
      copyright: '© National Sun Yat-sen University EMI Center. All rights reserved.',
      reservationSystem: 'English Enhancement Activity Reservation System',
      developedBy: 'Developed by ',
      totalViews: 'Total Views',
      todayViews: 'Today\'s Views',
    },
    home: {
      loading: 'Loading...',
      loadingEvents: 'Loading events...',
      checkReservation: 'Check Reservation',
      faq: 'FAQ',
      activityIntro: 'Activities',
      notice: 'Notice',
      noticeSurveyBefore: 'If you already checked in to English Table or English Club this semester, complete the ',
      noticeSurveyLink: 'survey',
      noticeSurveyAfter: ' before booking it again. You do not need it until you have checked in.',
      ruleUpdate: 'Rule Update',
      ruleNoStamp: 'From semester 114-1, make-up stamp service is no longer provided. Please attend on time.',
      ruleNoWalkIn: 'Waitlisting is not available (online or walk-in). If a session is full, please choose another one and reserve in advance.',
      month: 'Month',
      list: 'List',
      today: 'Today',
      prevMonth: 'Previous month',
      nextMonth: 'Next month',
      prevWeek: 'Previous week',
      nextWeek: 'Next week',
      gotIt: 'Got it',
      usageTitle: 'Reservation System Guide',
      usageLoginTitle: 'Sign in with the campus portal',
      usageLogin: 'Use your student ID and the password from sso.nsysu.edu.tw. You do not create a separate account; the first successful sign-in opens it. A password you set earlier on this site no longer works.',
      usageCampusTitle: 'Sign in with the campus portal',
      usageCampusLogin: 'Enter your student ID and the password from sso.nsysu.edu.tw. You do not create a separate account; the first successful sign-in opens it.',
      usageCampusPassword: 'A password you set earlier on this site no longer works. Reset a forgotten, default, or expired password on the campus portal first.',
      usageCampusMail: 'After the first sign-in, confirm your mailbox under My Account with the verification code. Booking stays closed until the account is activated.',
      usageRule: 'Rule Update:',
      usageBlacklist: 'Students who accumulate two violations in the same semester will be blacklisted for two weeks.',
      usageViolations: 'Violations include:',
      usageV1: 'Failing to attend after a successful reservation',
      usageV2: 'Leaving the activity without a valid reason',
      usageV3: 'Arriving more than 5 minutes after the start of any English Enhancement activities',
      usageCancel: 'To cancel, sign in and open My Reservations. Enter the code from your booking email before the deadline shown on that reservation. The deadline depends on the activity type.',
      usageCancelEn: 'To cancel, sign in and open My Reservations. Enter the code from your booking email before the deadline shown on that reservation. The deadline depends on the activity type.',
      usageButtonPrimary: 'Got it',
      usageButtonSecondary: 'Noted',
      noted: 'Noted',
      eventDetailsToggle: 'Expand or collapse event summary',
      eventStatusOpen: 'Open for reservation',
      eventStatusClosed: 'Not available to reserve',
      surveyRequiredBadge: 'Survey required (ET / EC)',
      spotsLeftLabel: 'Spots left',
      calendarAlertFull: 'This session is full.',
      calendarAlertStarted: 'The activity has already started; reservations are closed.',
      calendarAlertNotOpen: 'Not open for reservation yet. Window: {{start}} — {{end}}',
      calendarAlertPastDeadline: 'The reservation period has ended.',
      eventHoverBadgeOpen: 'Open',
      eventHoverBadgeFull: 'Full',
      eventHoverBadgeNotOpenYet: 'Not yet open',
      eventHoverBadgeReservationEnded: 'Reservation closed',
      eventHoverBadgeEventStarted: 'In progress',
      eventHoverBadgeUnavailable: 'Unavailable',
      eventHoverSurveyShort: 'Survey',
      eventHoverSurveyAria: 'Survey must be completed before reserving this session',
      eventHoverSpotsPrefix: 'Spots left: ',
      eventHoverLocationLabel: 'Location:',
      eventHoverCardAria: 'Event preview summary',
      eventCtaViewDetail: 'View details',
      eventCtaBookNow: 'Reserve now',
    },
    activities: {
      title: 'Activities',
      filterEmptyTitle: 'No sessions in this category',
      filterEmptyDesc: 'Try another activity type or view all activities.',
      showAllActivities: 'Show all activities',
      noEventsTitle: 'No sessions available',
      noEventsDesc: 'It may be a break, or sessions have not been announced yet. You can still read activity intros, check existing bookings, or practice for 5 minutes.',
      noEventsCtaActivities: 'Activity intro',
      noEventsCtaReservations: 'My reservations',
      noEventsCtaPractice: 'Practice 5 minutes',
      englishTable: 'English Table',
      englishClub: 'English Club',
      internationalForum: 'International Forum',
      jobTalk: 'Job Talk',
      jobTalkFull: 'Job Talk: Interview and Career English',
      etDesc: 'English Table is a short English exchange activity, often connected to course topics or instructor planning. Students practice explaining class content and sharing ideas in small-table discussion, making it a good choice for focused practice without joining a long session.',
      etCourseColearning: 'Course Co-learning',
      etCourseColearningDesc: 'Integrating EMI English-taught courses to create a diverse range of topics and a bilingual learning environment.',
      etInternational: 'International Exchange',
      etInternationalDesc: 'Combining thematic courses to exchange international cultural topics, simultaneously developing English proficiency and global perspectives.',
      ecDesc: 'English Club centers on themed discussion and interactive speaking practice. International instructors or professional facilitators guide students to speak more, respond to others, and build confidence in a relaxed English-speaking setting.',
      ecFeatures: 'Activity Features',
      ecFeaturesDesc: 'Through the guidance of professional international instructors, students can naturally improve their English communication skills in a relaxed environment and develop cross-cultural understanding and critical thinking.',
      ifDesc: 'International Forum connects local and international students through global issues, cultural differences, and current topics. Students practice explaining their own perspectives in English while learning how people from different backgrounds think and communicate.',
      ifGoals: 'Activity Goals',
      ifGoalsDesc: 'Promote cross-cultural understanding, build international friendships, and enhance English expression and communication skills through discussions.',
      jtDesc: 'Job Talk focuses on career English, including self-introductions, interview answers, resume stories, and workplace communication. Sessions usually use scenario practice or discussion, and are useful for students preparing for interviews, exchange programs, internships, or future work.',
      jtFeatures: 'Activity Features',
      jtFeaturesDesc: 'Through practical role-playing, mock interviews, and resume-based oral activities, students will practice the English skills truly needed in the workplace, learning to communicate clearly, professionally, and persuasively.',
      jtObjectives: 'Learning Objectives',
      jtObjectivesDesc: 'These activities are designed to strengthen the core objectives of the English Proficiency Test—oral proficiency (including fluency, pronunciation, and confident expression)—helping participants develop communication skills valued in both the test framework and today\'s global workplace.',
      writingWorkshop: 'English Writing Workshop',
      wwDesc: 'The English Writing Workshop offers writing support, resources, and activities to strengthen academic and practical English writing. Visit the official site for registration and schedules (managed separately from EEARS booking).',
      photoCount: '',
    },
    activitiesPage: {
      title: 'Activities and Booking',
      kicker: 'Activity guide',
      overviewTitle: 'Understand each activity before choosing a session',
      overviewLead: 'This page explains the main activity types, learning context, format, and booking entry points. If you already know what you need, go straight to the calendar for open sessions.',
      bookFromCalendar: 'Book from calendar',
      flowLead: 'Choose an activity, confirm your details, complete booking, and attend on time to build your record.',
      step1ToolsKicker: 'Step 01 helpers',
      wordBridgeToolTitle: 'Word Bridge',
      wordBridgeToolLead: 'Group words by theme to estimate a good starting activity.',
      wordBridgeToolCta: 'Start Word Bridge',
      wordBridgeToolEmpty: 'Complete a Word Bridge round to see activity suggestions here.',
      wordBridgeToolLevel: 'Latest estimate: {{level}}',
      practiceResourcesCta: 'Practice on Learning Resources',
      styleToolTitle: 'Learning style',
      styleToolLead: 'Pick your pace and focus for activity suggestions (this session only).',
      styleToolCta: 'Set learning style',
      styleToolEdit: 'Edit learning style',
      styleToolSummary: 'Pace: {{density}}; Focus: {{focus}}',
      recommendedActivities: 'Suggested activities',
      wordBridgeCta: 'Quick English level check',
      catalogKicker: 'Programs',
      catalogTitle: 'Activity types',
      catalogLead: 'Choose by goal and context. Card order rotates each visit. English Table for course topics, English Club for speaking practice, Job Talk for career English, and the Writing Workshop site for writing support. Open types follow this page and the calendar.',
      scheduleKicker: 'Schedule',
      scheduleTitle: 'Activity time guide',
      scheduleLead: 'This table summarizes the usual timing and format. Actual dates, venues, seats, and booking availability are shown on the calendar.',
      tableActivity: 'Activity',
      tableTime: 'Typical time',
      tableFormat: 'Format',
      tableBooking: 'Booking',
      tableBookingLink: 'View sessions',
      calendarTitle: 'View upcoming open sessions',
      fitLabel: 'Best for',
      formatLabel: 'Format',
      durationLabel: 'Typical time',
      etImageAlt: 'Students discussing course topics around a table',
      ecImageAlt: 'Students practicing English speaking in a small group',
      ifImageAlt: 'Local and international students exchanging cultural topics',
      jtImageAlt: 'Students practicing career English and interview communication',
      etFit: 'Discuss course content and practice concise expression',
      ecFit: 'Speak more often and get used to discussion flow',
      ifFit: 'Exchange with international students and discuss culture or issues',
      jtFit: 'Prepare interview answers, resume stories, or workplace English',
      etFormat: 'Course-linked, small-table exchange',
      ecFormat: 'Instructor-led thematic discussion',
      ifFormat: 'Intercultural topics and exchange',
      jtFormat: 'Scenario practice and career communication',
      etDuration: 'About 30 minutes',
      ecDuration: 'By announced session',
      ifDuration: 'By announced session',
      jtDuration: 'By announced session',
      etSchedule: 'About 30 minutes, usually arranged with course or instructor planning',
      ecSchedule: 'By semester announcement, usually built around thematic discussion',
      ifSchedule: 'By center announcement, arranged around international exchange topics',
      jtSchedule: 'By center announcement, arranged around interviews, resumes, or career topics',
      etVisual1: 'Course topic',
      etVisual2: 'Small-table talk',
      etVisual3: 'Live practice',
      ecVisual1: 'Instructor-led',
      ecVisual2: 'Theme discussion',
      ecVisual3: 'Speaking confidence',
      ifVisual1: 'International students',
      ifVisual2: 'Cultural topics',
      ifVisual3: 'Exchange',
      jtVisual1: 'Interview practice',
      jtVisual2: 'Resume story',
      jtVisual3: 'Career English',
      visitExternalSite: 'Visit official site',
      wwFit: 'Structured academic or practical writing practice',
      wwFormat: 'Writing support, resources, and center activities',
      wwDuration: 'Per workshop announcement',
      wwVisual1: 'Writing support',
      wwVisual2: 'Academic writing',
      wwVisual3: 'Writing resources',
    },
    announcementsPage: {
      heroLead: 'Activity updates, registration reminders, and center news.',
      hintPinned: 'Pinned',
      hintPinnedDesc: 'Important notices appear at the top',
      hintCategory: 'Category',
      hintCategoryDesc: 'Identify notice types quickly',
      hintPublished: 'Published',
      hintPublishedDesc: 'Only published notices appear here',
      badgePinned: 'Pinned',
      filterSearch: 'Search',
      filterSearchPlaceholder: 'Title, summary, slug…',
      filterCategory: 'Category',
      filterCategoryAll: 'All categories',
      filterTag: 'Tag',
      filterTagPlaceholder: 'Single tag keyword',
      filterApply: 'Apply',
      filterReset: 'Reset',
      emptyDescription: 'New announcements will appear here when published.',
      copyLink: 'Copy link',
      copyLinkDone: 'Link copied',
      readingMinutes: '~{{minutes}} min read',
      updatedAt: 'Updated',
      goBookActivity: 'Book an activity',
    },
    learningStyleModal: {
      done: 'Done',
      close: 'Close',
    },
    speakingCheck: {
      title: 'Speaking check',
    },
    wordBridge: {
      pageTitle: 'Word Bridge: find your English starting point',
      pageLead: 'Group four words by theme, climb from A1 to C2, and get a CEFR band estimate plus activity recommendations.',
      sectionKicker: 'Self check',
      sectionTitle: 'Word Bridge: find your English starting point',
      sectionLead: 'Group four words by theme, climb from A1 to C2, and get a CEFR band estimate plus activity recommendations.',
      kicker: 'Word Bridge',
      title: 'Word Bridge',
      introLead: 'Each round uses one CEFR band. Find every four-word theme group before time runs out—solved groups stay on the board.',
      rule1: 'Select four words from the same theme, then tap Submit group. (e.g. four colors, four animals)',
      rule2: 'Five mistakes for the whole run. Each round allows 40–110 seconds (shortest at A1, longest at C2). Wrong submits and timeouts do not change the word set.',
      rule3: 'Clear every group in a band to advance. If you run out of mistakes, your estimate is one band below where you stopped (e.g. stop on B1 → A2). One manual New set per run replaces unsolved groups only.',
      start: 'Start at A1',
      startChallenge: 'Start challenge',
      startLevelLegend: 'Choose your starting band',
      surveyKicker: 'Quick survey',
      surveyTitle: 'Your learning style',
      surveyLead: 'Two quick questions to tailor activity suggestions for this visit only (not saved to our systems).',
      surveyDensityLegend: 'What pace do you prefer?',
      surveyDensity: {
        high: 'High density: longer sessions, deeper discussion',
        balanced: 'Balanced: flexible by activity',
        low: 'Low density: short, light sessions',
      },
      surveyFocusLegend: 'What do you want to strengthen most?',
      surveyFocus: {
        speaking: 'Speaking and discussion',
        balanced: 'Balanced skills',
        writing: 'Writing and written expression',
      },
      surveyBack: 'Back',
      surveyContinue: 'Start challenge',
      surveyDisclaimer: 'Answers are used only for this session and are cleared when you close the tab.',
      visitExternalSite: 'Visit official site',
      disclaimer: 'For self-assessment only. Choose courses and activities with your instructor’s guidance.',
      levelKicker: 'Current level',
      passedLevels: 'Cleared: {{levels}}',
      levelUp: 'Advanced to {{level}}!',
      timerLabel: 'sec',
      timerAria: '{{seconds}} seconds left',
      groupProgress: '{{solved}} / {{total}} groups done',
      playingHint: 'Pick four words from one theme, then tap Submit group.',
      mistakesAria: '{{left}} tries left out of {{max}}',
      mistakesLeft: '{{count}} left',
      gridAria: 'Word selection grid',
      shuffle: 'Shuffle',
      swapQuestions: 'New set',
      submitGroup: 'Submit group',
      roundCompleteKicker: 'Round complete',
      roundCleared: 'Round cleared',
      roundEnded: 'Round ended',
      roundClearedLead: 'You finished round {{current}} of {{total}}. Continue or view your recommendations.',
      roundEndedLead: 'You used all mistakes, but you can still view recommendations from your progress.',
      nextRound: 'Next round',
      viewResults: 'View recommendations',
      resultsKicker: 'Your fit',
      resultsTitle: 'Your vocabulary band and activity fit',
      estimatedLevel: 'Estimated familiar band',
      resultsLead: 'Recommendations below come from your vocabulary run and your learning preferences—use either or both.',
      resultsLevelSection: 'From vocabulary check',
      resultsLevelLead: 'Based on the highest band you cleared and where the run ended.',
      resultsStyleHint: 'For pace and focus suggestions, use Learning style on the Activities page.',
      resultsPreferenceSection: 'From learning preferences',
      resultsPreferenceLead: 'Based on the pace and focus you chose before starting.',
      bookActivity: 'Book this activity',
      playAgain: 'Play again',
      viewMistakeWords: 'View mistaken words',
      mistakeWordsTitle: 'Words from wrong groups',
      mistakeWordsLead: 'Words you selected in incorrect submissions (deduplicated), for review.',
      mistakeWordsClose: 'Close',
      mistakeTabList: 'Word list',
      matchTitle: 'Match review',
      matchStart: 'Start matching',
      matchIntroLead: 'Tap English and Chinese pairs. Up to 16 cards (8 pairs) per round. Matched words stay out until you finish or exit; review words fill in when needed.',
      matchEligibleHint: 'Matching is available when you have 4+ mistaken words from B1 or above.',
      matchProgress: '{{mastered}} / {{total}} pairs mastered',
      matchRound: 'Round {{round}}',
      matchGridAria: 'Match cards',
      matchReviewTag: 'Review',
      matchExit: 'Exit matching',
      matchCompleteTitle: 'Matching complete',
      matchCompleteLead: 'You mastered {{mastered}} / {{total}} mistaken word pairs.',
      matchPlayAgain: 'Practice again',
      matchBackToList: 'Back to list',
      resultSessionStats: '{{duration}} played · {{mistakes}} / {{max}} mistakes',
      shareResult: 'Share result',
      shareTitle: 'Word Bridge result',
      shareText: 'I reached about {{level}} on Word Bridge at NSYSU English Excellence in EMI Center ({{duration}}, {{mistakes}}/{{max}} mistakes). Try it! {{url}}',
      shareDone: 'Share opened',
      shareCopied: 'Result copied to clipboard',
      shareFailed: 'Could not share. Please try again.',
      goCalendar: 'Open calendar',
      levelA1: 'Starter words',
      levelA2: 'Everyday words',
      levelB1: 'Study & discussion words',
      levelB2: 'Advanced expression words',
      levelC1: 'Proficient academic words',
      levelC2: 'Mastery-level professional words',
      confidence: {
        high: 'Confidence: high',
        medium: 'Confidence: medium',
        low: 'Confidence: low (start with foundational sessions)',
      },
      activityTag: {
        'english-table': 'ET',
        'english-club': 'EC',
        'international-forum': 'IF',
        'job-talk': 'JT',
        'writing-workshop': 'WW',
      },
      activityReason: {
        'english-table': 'Good for course-linked topics and short speaking practice.',
        'english-club': 'Good for speaking more often and building discussion confidence.',
        'international-forum': 'Good for intercultural topics and explaining your views.',
        'job-talk': 'Good for interview practice and professional communication.',
        'writing-workshop': 'Structured writing support and resources on the official site.',
      },
    },
    miniGames: {
      wordBridgeIntro: 'Word matching · about 8 minutes. Find your starting point—this is not a test.',
      listeningLadderIntro: 'Listening vocab · 90 seconds. Hear English, pick Chinese.',
      vocabularyDepthIntro: 'Vocabulary depth · about 6 minutes. Synonyms, collocations, and idioms—beyond Word Bridge.',
      vocabularySizeIntro: 'Vocabulary size · about 2 minutes. Mark 50 words you know; we estimate total vocabulary and CEFR band.',
      speakingCheckIntro: 'Enter the code from your teacher and complete the speaking set in order. Practice feedback, not a formal test.',
      wordBridgeTime: 'About 8 min',
      listeningLadderTime: '90 seconds',
      vocabularyDepthTime: 'About 6 min',
      vocabularySizeTime: 'About 2 min',
      speakingCheckTime: 'A question set',
      practiceKicker: 'Practice now',
      practiceTitle: 'Mini practice',
      practiceLead: 'Short interactive drills to warm up before activities. Scores and results are for practice, not formal testing.',
      guidesKicker: 'Prepare',
      guidesTitle: 'Before you speak',
      guidesLead: 'Scenario cards and response ideas to lower speaking anxiety. No scores, no right-or-wrong.',
      startPractice: 'Start practice',
      openGuide: 'Open guide',
    },
    listeningLadder: {
      pageTitle: 'Listening Ladder',
      pageLead: 'Hear an English word and pick the correct Chinese meaning—90 seconds on the clock.',
      kicker: 'Listening Ladder',
      title: 'Listening Ladder',
      introLead: 'Listen to an English word and choose the correct Chinese translation from four options. Difficulty adjusts as you play.',
      howToPlay: 'How to play',
      rule1: 'Each round lasts 90 seconds—answer as many items as you can.',
      rule2: 'Each word plays automatically at the start of a question. Tap Listen again if you need another pass.',
      rule3: 'Consecutive correct answers move you up (A1→A2→B1→B2→C1); consecutive misses may move you down.',
      rule4: 'Wrong answers do not heavily penalize your score—keep going.',
      getReady: 'Get ready',
      start: 'Start 90-second challenge',
      volumeHint: 'Check volume or use headphones. On mobile, tap Test sound before the round.',
      testSound: 'Test sound',
      timerLabel: 'sec',
      timerAria: '{{seconds}} seconds left',
      currentLevel: 'Current level',
      streak: 'Streak',
      highest: 'Highest',
      playWord: 'Play word',
      replay: 'Listen again',
      score: 'Score',
      feedbackCorrect: 'Correct',
      feedbackIncorrect: 'Try again—the answer was',
      speechUnsupported: 'Speech is not supported in this browser. Try another browser or device.',
      speechFailed: 'Could not play audio. Check volume or tap Play again.',
      loadError: 'Could not load questions. Please try again later.',
      resultsKicker: 'Round complete',
      resultsTitle: 'Your results',
      resultScore: 'Score',
      resultCorrect: 'Correct',
      resultAccuracy: 'Accuracy',
      resultHighest: 'Highest level reached',
      resultStreak: 'Best streak',
      resultWords: 'Words heard',
      resultDuration: 'Duration',
      resultAnswerLog: 'Answer log',
      resultAnswerSelected: 'Your answer: {{answer}}',
      resultAnswerExpected: 'Correct Chinese: {{answer}}',
      resultAnswerCorrect: 'Correct',
      resultAnswerWrong: 'Incorrect',
      personalBest: 'Personal best: {{score}} pts (up to {{level}} items)',
      cefrDisclaimer: 'Highest level reached reflects items you answered correctly in this session only—not an official CEFR certification.',
      playAgain: 'Play again',
      wordBridgeCta: 'Play Word Bridge next',
      bookSessionCta: 'Book a session',
      phrasebookCta: 'Activity phrasebook',
      backToLearningResources: 'Back to Learning Resources',
      backToActivities: 'More learning resources',
    },
    vocabularyDepth: {
      pageTitle: 'Vocabulary Depth',
      pageLead: 'From definitions and context to synonyms, collocations, and idioms—an A1–C1 self-check (not certification).',
      kicker: 'Vocabulary Depth',
      title: 'Vocabulary Depth',
      introLead: 'Six multiple-choice items per CEFR band. Pass each band threshold to advance. Explanations appear after each answer.',
      howToPlay: 'How to play',
      rule1: 'Start at A1 and progress through C1 (this test does not grade C2).',
      rule2: 'Pass a band with at least 4/6 correct (about two-thirds).',
      rule3: 'If you fail a band, your estimate is the last band you passed.',
      rule4: 'Results are for self-assessment—keep practicing through center activities.',
      start: 'Start test',
      disclaimer: 'For self-assessment only. Choose activities based on your situation and instructors’ advice.',
      levelLabel: 'Current band',
      questionProgress: 'Question {{current}} / {{total}}',
      feedbackCorrect: 'Correct',
      feedbackIncorrect: 'Not quite—see the explanation',
      resultTitle: 'Your vocabulary depth result',
      estimatedLevel: 'Estimated band: {{level}}',
      accuracy: 'Overall accuracy: {{pct}}%',
      recommendedActivities: 'Suggested center activities',
      playAgain: 'Try again',
      listeningCta: 'Play Listening Ladder next',
      wordBridgeCta: 'Play Word Bridge next',
      bookActivityCta: 'Book a session',
      cefrDisclaimer: 'Estimated band reflects this session only—not an official CEFR certification or exam score.',
    },
    vocabularySize: {
      pageTitle: 'Vocabulary Size Test',
      pageLead: 'Quickly mark 50 English words you know; we extrapolate total vocabulary and an A1–C2 reference band (not certification).',
      kicker: 'Vocabulary Size',
      title: 'Vocabulary Size Test',
      introLead: 'Complements the depth test: this measures how many words you recognize, not how you use them in context.',
      howToPlay: 'How to play',
      rule1: '50 English words from 10 frequency bands (covering the most common ~10,000 words).',
      rule2: 'Be honest: tap “I know this” only if you can recall the meaning without guessing.',
      rule3: 'No Chinese options or definitions—just the English word.',
      rule4: 'Results show estimated vocabulary size, CEFR band, and suggested center activities.',
      start: 'Start test',
      disclaimer: 'Results are statistical estimates for self-reference—pair with depth practice and real activities.',
      wordProgress: 'Word {{current}} / {{total}}',
      bandLabel: 'Band {{band}} / 10',
      prompt: 'Do you know what this English word means?',
      know: 'I know this',
      dontKnow: "I don't know",
      resultTitle: 'Your vocabulary size estimate',
      estimatedWords: 'About {{count}} English words',
      estimatedLevel: 'CEFR reference band: {{level}}',
      recognition: 'Recognition rate this session: {{pct}}%',
      wordsToNext: 'About {{count}} more words to the next band (estimate)',
      recommendedActivities: 'Suggested center activities',
      playAgain: 'Try again',
      depthCta: 'Try Vocabulary Depth next',
      wordBridgeCta: 'Play Word Bridge next',
      bookActivityCta: 'Book a session',
      cefrDisclaimer: 'Vocabulary size and CEFR mapping are approximate—not an official certification or exam score.',
    },
    etTopics: {
      pageTitle: 'Semester topics',
      pageLead: 'Every 115-1 English Table topic is listed here. You can read the questions before booking opens.',
      thisWeek: 'This week',
      today: 'Today',
      backToEnglishTable: 'Back to English Table',
    },
    phrasebook: {
      pageTitle: 'Activity Phrasebook',
      pageLead: 'Language support before English Table, English Club, International Forum, and Job Talk.',
      kicker: 'Learning Guide',
      title: 'Activity Phrasebook',
      catalogIntro: 'Scenarios, response directions, and A2/B1/B2 examples to lower speaking anxiety.',
      noScoreNote: 'This is language scaffolding—not a quiz: no scores, no right-or-wrong, no leaderboard.',
      filterLabel: 'Filter by activity',
      tab: {
        all: 'All',
        'english-table': 'English Table',
        'english-club': 'English Club',
        'international-forum': 'International Forum',
        'job-talk': 'Job Talk',
      },
      panelKicker: 'Before you join',
      panelTitle: 'Phrasebook for this activity',
      panelLead: 'Common scenarios for this activity type—browse before you attend.',
      viewAll: 'View full phrasebook',
      quickPrepTitle: '5-minute prep',
      quickPrepLead: 'Start with these scenarios before the session.',
      backToActivities: 'Back to activities',
    },
    events: {
      trustStatsAria: 'Activity overview stats',
      statUpcoming: 'Upcoming',
      statUpcomingHint: 'Sessions not yet started',
      statOpenNow: 'Open now',
      statOpenNowHint: 'Available to book',
      statClosingSoonHint: '{{count}} closing soon',
      statTotalSessions: 'Listed sessions',
      statTotalSessionsHint: 'Total on this calendar',
      statSiteViews: 'Total visits',
      statTodayViews: '{{count}} today',
      state: {
        OPEN: 'Open',
        CLOSING_SOON: 'Closing soon',
        NOT_YET_OPEN: 'Not yet open',
        PAST_DEADLINE: 'Closed',
        STARTED: 'In progress',
        FULL: 'Full',
        UNKNOWN: 'Unknown',
      },
      closingSoonTag: 'Closing soon',
      windowLabel: 'Reservation window:',
      reservationWindow: '{{start}} — {{end}} (closes 2 hr before start)',
      opensAt: 'Opens at {{time}}',
      openUntil: 'Closes {{time}} ({{countdown}})',
      cutoffRule: 'Reservations close {{hours}} hours before the activity starts.',
      fullDetail: 'This session is full. Please choose another one.',
      deadlinePassed: 'Past deadline',
      deadlineMinutesLeft: '~{{minutes}} min left',
      deadlineHoursLeft: '~{{hours}} hr left',
      deadlineDaysLeft: '~{{days}} days left',
    },
    booking: {
      modalTitle: '{{name}} · Reservation',
      stepAria: 'Booking progress',
      step1: 'Your details',
      step2: 'Survey',
      step3Reserve: 'Confirmed',
      step3Waitlist: 'Done',
      summaryAria: 'Session details',
      sessionPanelTitle: 'Session',
      detailsPanelTitle: 'Details',
      labelName: 'Activity',
      labelType: 'Type',
      labelDate: 'Date',
      labelTime: 'Time',
      labelLocation: 'Location',
      labelSpots: 'Spots left',
      spotsFull: 'Full',
      badgeWaitlist: 'Full',
      badgeSurvey: 'Survey required',
      sectionTiming: 'Booking window',
      timingOpen: 'Opens',
      timingClose: 'Closes',
      timingRule: 'Booking rule',
      timingCutoffNote: '(closes 2 hr before start)',
      sectionNotes: 'Important',
      note1: 'From semester 114-1, make-up stamp service is no longer provided. Please attend on time.',
      note2: 'Cancellations must be completed at least 2 hours before the activity starts.',
      note3: 'English Table / English Club may require a completed semester survey before booking.',
      etTopicLabel: 'Topic',
      etTopicSummary: 'This week’s topic',
      etTopicWeek: 'Week {{week}}',
      etTopicHoliday: 'National holiday. There is no discussion topic today.',
      etTopicChartNote: 'This session uses a chart. The chart is provided in class; you can read the questions first.',
      etTopicPassageLabel: 'Passage',
      etFormatConversation: 'Conversation',
      etFormatChart: 'Chart discussion',
      etFormatPassage: 'Passage and chart',
      etFormatDiscussion: 'Discussion',
      etFormatHoliday: 'Holiday',
      etTopicCatalogLink: 'See all topics this semester',
      formStudentId: 'Student ID',
      formName: 'Name',
      formEmail: 'Email',
      formSectionTitle: 'Your details',
      violationRemind: 'Reminder:',
      violationContinue: 'You may still continue, but please follow activity rules.',
      fullNoWaitlist: 'This session is full and cannot be booked. Please choose another session with available spots.',
      surveyStepMsg: 'This booking requires a survey. You will be guided to complete it, then your reservation will resume automatically.',
      surveyStepInfo: 'A survey is required first. You will be redirected to complete it, then return to finish booking.',
      btnCancel: 'Cancel',
      btnReserve: 'Reserve',
      btnWaitlist: 'Session full',
      btnProcessing: 'Processing...',
      btnBack: 'Back',
      btnSurveyPending: 'Opening survey...',
      btnClose: 'Close',
      blacklistTitle: 'Cannot reserve — blacklisted',
      blacklistHeading: 'You are currently blacklisted',
      blacklistBody: 'According to our records, you have {{count}} violation(s) and are blacklisted.',
      blacklistUntil: 'Blacklist ends:',
      blacklistViolationsTitle: 'Violations include:',
      blacklistViolation1: 'Failing to attend after a successful reservation',
      blacklistViolation2: 'Leaving without a valid reason',
      blacklistViolation3: 'Arriving more than 5 minutes after start',
      blacklistViolation4: 'Other violations of activity rules',
      blacklistRulesTitle: 'Policy:',
      blacklistRulesBody: 'Two violations in the same semester result in a two-week blacklist. You cannot reserve during this period.',
      blacklistAck: 'I understand',
      mobileContinue: 'Continue to details',
      mobileBackSession: 'Back to session',
      mobileSessionStep: 'Review session',
    },
    faq: {
      title: 'FAQ',
      cancel: 'Cancel Reservation',
      blacklist: 'Blacklist',
      rules: 'Activity Regulations',
      cancelQuestion: 'How to cancel your reservation?',
      cancelSteps: 'Steps to cancel:',
      cancelStep1: 'Click the "Check Your Reservation" button on the page',
      cancelStep2: 'Enter your name, student ID, and email address',
      cancelStep3: 'The system will display your reservation records',
      cancelStep4: 'Find the activity you want to cancel and click "Delete"',
      cancelStep5: 'After confirming, the reservation will be cancelled',
      importantReminder: 'Important',
      cancelRemind1: 'Reservations cannot be cancelled within 2 hours before the activity starts',
      cancelRemind2: 'If you cannot attend, please cancel at least 2 hours in advance',
      cancelRemind3: 'Failure to cancel and not attending will be considered a violation; two violations result in blacklisting',
      cancelRemind4: 'For assistance, please contact the EMI Center',
      blacklistQuestion: 'What happens if I\'m blacklisted?',
      blacklistMechanism: 'Blacklist policy:',
      blacklistRule: 'Students who accumulate two violations in the same semester will be blacklisted for two weeks.',
      violationsInclude: 'Violations include:',
      violation1: 'Failing to attend after a successful reservation',
      violation2: 'Leaving the activity without a valid reason',
      violation3: 'Arriving more than 5 minutes after the start of any English Enhancement activities',
      blacklistImpact: 'During blacklist period',
      impact1: 'Blacklist period is two weeks (14 days)',
      impact2: 'You cannot make any reservations during this period',
      impact3: 'After the period ends, violation records reset and you can reserve again',
      impact4: 'Please follow the rules to avoid being blacklisted',
      howToAvoid: 'How to avoid being blacklisted?',
      avoid1: 'Confirm you can attend before reserving',
      avoid2: 'If you cannot attend, cancel at least 2 hours before the activity',
      avoid3: 'Arrive on time; avoid being more than 5 minutes late',
      avoid4: 'Do not leave the activity without a valid reason',
      avoid5: 'For special circumstances, contact the EMI Center in advance',
      rulesTitle: 'English Enhancement Activity Regulations',
      rulesImportant: 'Important rules:',
      ruleNoOnsite: 'No on-site registration: All activities require online reservation in advance',
      ruleNoStampService: 'No make-up stamp service: From semester 114-1, make-up stamp service is no longer provided',
      ruleNoLate5: 'No entry after 5 minutes late: Arriving more than 5 minutes after the start is considered a violation',
      ruleNoOnsiteDetail: 'No on-site registration',
      ruleNoOnsiteD1: 'All English Enhancement activities accept online reservation only',
      ruleNoOnsiteD2: 'Waitlisting is not available (online or walk-in); please reserve in advance',
      ruleNoOnsiteD3: 'Complete your reservation within the open reservation period',
      ruleNoOnsiteD4: 'If full, please choose another session or wait for the next activity',
      ruleNoStampDetail: 'No make-up stamp service',
      ruleNoStampD1: 'From semester 114-1, make-up stamp service is no longer provided',
      ruleNoStampD2: 'Please attend on time to receive the stamp',
      ruleNoStampD3: 'If you cannot attend, cancel in advance so others can participate',
      ruleNoStampD4: 'Missing the activity cannot be made up; please plan carefully',
      ruleLateDetail: 'No entry after 5 minutes late',
      ruleLateD1: 'Participants who arrive more than 5 minutes after the start will be considered in violation',
      ruleLateD2: 'Please arrive and check in before the activity starts',
      ruleLateD3: 'We recommend arriving 5–10 minutes early',
      ruleLateD4: 'Arriving more than 5 minutes late will not be allowed in and will be recorded as a violation',
      ruleLateD5: 'Two violations result in a two-week blacklist',
      otherRules: 'Other important rules',
      otherR1: 'Reservations cannot be cancelled within 2 hours before the activity',
      otherR2: 'Activities are conducted in English; please be prepared',
      otherR3: 'Do not leave the activity without a valid reason',
      otherR4: 'Please respect the instructors and other participants',
      otherR5: 'Follow the venue rules',
      bookingWindowTitle: 'When booking opens',
      bookingWindowEt: 'English Table / custom types: 12:00 noon the day before the activity',
      bookingWindowJt: 'Job Talk: 12:00 noon, 7 days before on the same weekday',
      bookingWindowEc: 'English Club: 12:00 noon the previous Wednesday',
      bookingWindowIf: 'International Forum: 12:00 noon the previous Friday',
      bookingWindowCutoff: 'All activities: booking and cancellation close 2 hours before start',
      englishVersion: '中文版',
    },
    elpPage: {
      heroTitle: 'English Learning Passport',
      heroDesc: 'Complete designated English learning tasks to earn points. Reach 100 points to complete the English proficiency certification.',
      guideKicker: 'Student guide',
      guideTitle: 'Learning Passport quick guide',
      guideDesc: 'Verify your email and apply for a passport, then submit task evidence to earn points. Certification completes automatically at 100 points — then export your certificate.',
      guideOpenLarge: 'Open full image',
      guideImageUrl: '',
      guideImageAlt: 'EEARS English Learning Passport student guide: apply, wait for approval, upload tasks, track points, and complete certification at 100 points',
      identifyTitle: 'Identify yourself',
      identifySubmit: 'Enter my passport',
      emailHint: 'Must be an NSYSU campus email (@student / @g-mail / @mail / @faculty.nsysu.edu.tw)',
      applyLead: 'You have not applied yet. Verify your email and submit an application to start earning points right away (no staff passport approval required).',
      applyButton: 'Apply for passport',
      completedMessage: 'You have reached the threshold and completed certification (auto-completed after approved points — no final review request needed).',
      exportCertificate: 'Export certificate (PDF)',
      submitSectionTitle: 'Available submissions',
      submitAction: 'Submit record',
    },
    homePage: {
      heroEyebrow: 'NSYSU EMI Center',
      heroTitle: '英語增能活動預約系統',
      heroTagline: 'English Enhancement Activity Reservation System',
      heroDescClassic: 'English Table, English Club, forums, and more — quick booking for NSYSU students.',
      heroSubtitle: 'Enhance your English ability',
      heroDesc: 'Browse activities, reserve online, look up or cancel bookings, and register for BESTEP.',
      heroServices: 'English Table, English Club, International Forum reservations; BESTEP and group registration; semester surveys.',
      heroCtaBrowse: 'Browse activities',
      heroCtaMyReservations: 'My reservations',
      heroCtaBestep: 'BESTEP registration',
      heroSecondaryNavAria: 'More links',
      heroServicesAria: 'Services offered on this site',
      heroBentoBestepDesc: 'Individual and group BESTEP registration',
      heroBentoCalendarDesc: 'Browse sessions on the calendar',
      heroCtaBook: 'Book Activity Now',
      heroCtaGroupAria: 'Primary actions on the home page',
      bentoSectionAria: 'Quick links on the home page',
      heroCtaActivities: 'View Activities',
      quickActionsTitle: 'Quick Actions',
      quickPanelTitle: 'Student tasks',
      quickBook: 'Book an Activity',
      quickBookDesc: 'Choose an activity and complete reservation',
      quickBookTag: 'Primary',
      quickMyReservation: 'My Reservations',
      quickMyReservationDesc: 'Sign in to view or cancel your reservations',
      quickSurvey: 'Semester Survey',
      quickSurveyDesc: 'Complete the survey to enable booking',
      quickSurveyDescIdle: 'No required survey right now. You will be prompted if ET/EC booking needs one.',
      quickRules: 'Rules & Violations',
      quickRulesDesc: 'Understand reservation and violation rules',
      quickPassport: 'English Learning Passport',
      quickPassportDesc: 'Earn points and apply for English proficiency certification',
      quickPractice: 'Practice for 5 minutes',
      quickPracticeDesc: 'Word matching or a 90-second listening drill',
      practiceNowKicker: '5-minute practice',
      practiceNowTitle: 'Practice now',
      practiceNowLead: 'Warm up even when no sessions are open. Word matching takes about 8 minutes; listening is 90 seconds.',
      practiceNowCtaMore: 'See all practice and websites',
      coreTasksKicker: 'Student desk',
      coreTasksTitle: 'Core Tasks',
      coreTasksLead: 'The most common student workflows are placed first, so visitors can book, check records, register, or submit learning evidence without hunting through the site.',
      coreTasksSecondaryCta: 'Check my reservations',
      taskBookTitle: 'Book upcoming activities',
      taskBookDesc: 'Browse English Table, English Club, and center sessions, then reserve after checking availability.',
      taskBookCta: 'Go to activities',
      taskReservationsTitle: 'Check or cancel reservations',
      taskReservationsDesc: 'Sign in to review your bookings and cancel with the email code before the deadline.',
      taskReservationsCta: 'Manage bookings',
      taskPassportTitle: 'Submit learning records',
      taskPassportDesc: 'Upload English learning evidence, collect points, and track review status.',
      taskPassportCta: 'Open passport',
      taskBestepTitle: 'BESTEP registration',
      taskBestepDesc: 'Start the BESTEP registration flow for individual or group registration needs.',
      taskBestepCta: 'Start registration',
      activitiesTitle: 'Upcoming Bookable Activities',
      activitiesKicker: 'Open sessions',
      activitiesLead: 'Start from an activity type, then check reservation windows, remaining seats, and booking rules.',
      viewAllActivities: 'View all activities',
      activityReserve: 'Book Now',
      activityLearnMore: 'Learn More',
      stepsTitle: 'How It Works',
      stepsKicker: 'How it works',
      step1: 'Choose an activity',
      step2: 'Confirm your info',
      step3: 'Submit and complete registration',
      step4: 'Attend on time and build your record',
      announcementsTitle: 'Latest Announcements',
      announcementsKicker: 'Updates',
      announcementsLead: 'Schedule changes, registration reminders, and center news.',
      studentServicesKicker: 'Student services',
      studentServicesTitle: 'Student Shortcuts',
      studentServicesLead: 'These links support reservation eligibility, learning records, and center notices that students need throughout the semester.',
      serviceSurveyMeta: 'Survey',
      serviceSurveyTitle: 'Semester survey',
      serviceSurveyDesc: 'Complete required surveys so English Table or English Club booking remains available.',
      servicePartnerMeta: 'Partner',
      servicePartnerTitle: 'Learning partner',
      servicePartnerDesc: 'Enter group BESTEP registration and related team status workflows.',
      serviceRulesMeta: 'Rules',
      serviceRulesTitle: 'Reservation and violation rules',
      serviceRulesDesc: 'Review cancellation deadlines, late arrival, no-show, and blacklist policies.',
      serviceNewsMeta: 'News',
      serviceNewsTitle: 'All announcements',
      serviceNewsDesc: 'Read center notices, activity changes, registration updates, and administrative reminders.',
      pinnedBadge: 'Pinned',
      viewAllAnnouncements: 'View All',
      readMore: 'Read more',
      noAnnouncements: 'No announcements at the moment.',
      announcementsEmptyBack: 'Back to main',
      announcementsEmptyActivities: 'View activities',
      announcementsError: 'Announcements could not be loaded.',
      announcementNotFound: 'This announcement was not found or is not published.',
      backToAnnouncementsList: 'Back to announcements',
      faqTitle: 'FAQ',
      faqKicker: 'FAQ',
      faq1Q: 'How do I reserve an activity?',
      faq1A: 'Open the calendar from Book an Activity and choose an open session. Sign in first; the booking uses your account student ID, name, and email. Then check the confirmation and attend at the announced time.',
      faq2Q: 'How do I choose the right activity type?',
      faq2A: 'Start from "Activity Intro." Choose English Table for course-topic practice, English Club for speaking practice, International Forum for intercultural exchange, and Job Talk for interviews or workplace English.',
      faq3Q: 'Can I cancel if I cannot attend?',
      faq3A: 'Yes. Sign in and open My Reservations before that activity’s cancellation deadline, then cancel with the code from your booking email. The deadline depends on the activity type. A no-show without cancellation is recorded as a violation.',
      faq4Q: 'Why do some activities require a survey first?',
      faq4A: 'Some English Table or English Club sessions require the semester survey first. The center uses the survey to understand participants and activity needs. If the system asks for it, complete the survey before returning to the calendar.',
      faq5Q: 'What if an activity is full?',
      faq5A: 'If a session is full, it cannot be booked. Waitlisting is not available. Please choose another session of the same type, or watch announcements and the calendar for new openings.',
      faq6Q: 'How are violations counted?',
      faq6A: 'Common violations include no-show after a successful booking, arriving later than the allowed time, or leaving without a valid reason. Two violations in the same semester result in a two-week blacklist during which you cannot reserve activities.',
      faq7Q: 'Will participation count toward learning records or certification?',
      faq7A: 'Participation records follow the center rules. To apply for English learning records or certification, open the English Learning Passport to check eligible items, upload materials, and track review status.',
      faq8Q: 'Is BESTEP registration the same as activity booking?',
      faq8A: 'No. Activity booking is for English Table, English Club, International Forum, Job Talk, and related events. BESTEP registration is a separate process; use the BESTEP registration entry.',
      faq9Q: 'When does booking open for each activity type?',
      faq9A: 'English Table and custom types open at 12:00 noon the day before. Job Talk opens at 12:00 noon 7 days before on the same weekday. English Club opens at 12:00 noon the previous Wednesday. International Forum opens at 12:00 noon the previous Friday. Booking and cancellation close 2 hours before start for all types. The calendar shows the exact window for each session.',
      contactTitle: 'Contact',
      contactKicker: 'Contact',
      contactLead: 'For help with reservations, registration, or account issues, reach the center using the details below.',
      contactPageLink: 'View contact on About Us',
      contactAddress: 'Address',
      contactAddressValue: 'Library and Information Building 10F, Siwan College, No. 70 Lianhai Rd., Gushan Dist., Kaohsiung',
      contactPhone: 'Phone',
      contactPhoneValue: '07-5252000 # 5808/5876',
      contactEmail: 'Email',
      contactEmailValue: 'emicenter@mail.nsysu.edu.tw',
      contactHours: 'Hours',
      contactHoursValue: 'Mon–Fri 09:00–17:00',
      contactUs: 'Contact Us',
      goToCenter: 'Center Website',
      footerHome: 'Home',
      footerAnnouncements: 'Announcements',
      footerActivities: 'Activity Intro',
      footerLearningResources: 'Learning Resources',
      footerCourseGuide: 'Course Guide',
      footerRegulationsForms: 'Regulations & Forms',
      footerAbout: 'About',
      footerEvents: 'Book Sessions',
      footerMyReservations: 'My Reservations',
      footerProgress: 'My English Progress',
      footerFaq: 'FAQ',
      footerContact: 'Contact',
      footerPrivacy: 'Privacy',
      footerTerms: 'Terms',
      footerAdmin: 'Admin',
    },
    learningResourcesPage: {
      title: 'Learning Resources',
      lead: 'Practice games, speaking guides, and related materials to keep building English before and after activities.',
      sitesKicker: 'External sites',
      sitesTitle: 'Learning websites',
      sitesLead: 'Each site has a different job: listening, quizzes, reading, or speaking/writing tests. Cards open in a new tab.',
      sitesTag: 'Website',
      sitesCardLead: 'External learning platform',
      sitesLiveAbc: 'Listening and everyday English video lessons',
      sitesEasyTest: 'On-campus online quizzes and practice',
      sitesWalkingLibrary: 'Library e-resources and reading',
      sitesCoolEnglish: 'MOE English platform (listening, speaking, reading, writing)',
      sitesTeemi: 'English speaking and writing assessment',
      openWebsite: 'Open Website',
    },
    regulationsFormsPage: {
      title: 'Regulations & Forms',
      lead: 'A single place for English proficiency regulations, certification rules, rewards, and application forms.',
      note: 'Files are grouped by topic and language. Click any card to open the PDF or form in a new tab.',
      faqTitle: 'FAQ',
      faqDesc: 'Common questions about booking, cancellation, violations, and the blacklist.',
      privacyDesc: 'How we collect, use, and protect personal data.',
      termsDesc: 'System rules and terms of service.',
      openLink: 'Open',
      openFile: 'Open File',
      fileCount: '{{count}} files',
      statsSummary: '{{sections}} categories · {{files}} files',
      expandAll: 'Expand all',
      collapseAll: 'Collapse all',
      enrollYearLabel: 'Enrollment year:',
      enrollYearPlaceholder: 'e.g. 113',
      enrollYearTag: 'Year {{year}}',
      enrollYearHint: 'Enter a 3-digit year to show only applicable files',
    },
    aboutPage: {
      heroEyebrow: 'NSYSU Siwan College',
      heroTitle: 'Center for EMI Teaching Excellence',
      heroLead:
        'Promoting EMI teaching and English enhancement activities in a vibrant, learning-centered environment.',
      heroLocation: '10F, Library & Information Building, Siwan College · 70 Lianhai Rd., Gushan, Kaohsiung',
      scrollHint: 'Scroll to explore',
      heroJourneyHint: 'Scroll down to follow a learning journey from enrollment to graduation.',
      progressAria: 'About page progress',
      progressIntro: 'Intro',
      progressStory: 'Journey',
      progressActivities: 'Activities',
      progressTeam: 'Team',
      progressCta: 'Start',
      missionKicker: 'About the Center',
      missionTitle: 'Our story and mission',
      missionStepsAria: 'Center introduction chapters',
      missionStep1: 'Background',
      missionStep2: 'Core values',
      missionStep3: 'Mission',
      missionStep4: 'Teaching goals',
      journeyStep5: 'Services',
      journeyStep6: 'Graduation',
      journeyGraduateTitle: 'Make English part of everyday life',
      journeyGraduateBody:
        'From enrollment and classes to activities and learning records, the center walks with you toward graduation. Next, choose an enhancement activity and take the next step.',
      originTitle: 'Born from bilingual education policy',
      originBody:
        'In support of national bilingual education initiatives, National Sun Yat-sen University established the Center for EMI Teaching Excellence at Siwan College in the first semester of AY 2021, integrating EMI teaching and English enhancement resources across campus.',
      valuesTitle: 'What we believe',
      valuesBody:
        'We leverage the university’s distinctive environment and strong administrative organization, bringing together excellent faculty to create engaging teaching materials and methods that build learners’ confidence and interest.',
      purposeTitle: 'What we do',
      purposeBody:
        'We provide quality general education experiences, support innovative teaching, help faculty reach their goals, and strengthen partnerships across campus to foster a dynamic, knowledge-rich learning community.',
      goalsTitle: 'Where we are headed',
      goal1: 'Build a natural, diverse, and inclusive EMI teaching and learning environment.',
      goal2: 'Strengthen students’ academic competencies and communication skills in English.',
      goal3: 'Support faculty development and sharing of pedagogy, innovation, and resources.',
      goal4: 'Foster a flexible, knowledge-rich faculty–student community and exchange platform.',
      platformKicker: 'Digital services',
      platformTitle: 'Online reservation and learning services',
      platformBody:
        'This is the center’s official website, integrating activity reservations, BESTEP registration, learning records, and semester surveys in one place.',
      platformBookDesc: 'Browse sessions, reserve online, and manage bookings.',
      platformBestepDesc: 'Individual and group BESTEP registration flows.',
      platformPassportDesc: 'Track learning records and apply for certification.',
      activitiesKicker: 'English Enhancement',
      activitiesTitle: 'Enhancement activities',
      activitiesLead:
        'From classroom follow-up and speaking practice to international exchange and workplace English—choose what fits your goals.',
      activityCta: 'Learn more',
      ctaTitle: 'Ready to get started?',
      ctaLead: 'Browse open sessions to reserve, or contact the center for help.',
      ctaBook: 'Reserve an activity',
      ctaContact: 'Contact us',
      centerIntro:
        'The EMI Center at NSYSU Siwan College promotes EMI teaching and English enhancement activities, including English Table, English Club, and International Forum programs.',
      eearsIntro:
        'This site integrates activity reservations, BESTEP registration, learning records, and semester surveys—browse events, reserve online, and complete required steps.',
      facultyTitle: 'Faculty',
      facultyLead: 'Faculty supporting English enhancement programs',
      adminTitle: 'Administrative Team',
      adminLead: 'Center administration and project support',
      phoneExt: 'ext.',
      sourceTeam: 'Full faculty list',
      sourceAdmin: 'Full admin team',
      viewOnCenterSite: 'Learn more',
    },
    privacyPage: {
      title: 'Privacy Policy',
      lastUpdated: 'Last updated: March 2026',
      intro: 'The National Sun Yat-sen University EMI Center and the English Enhancement Activity Reservation System (EEARS) respect and protect your personal data. This policy explains how we collect, use, store, and protect your information.',
      section1Title: '1. Data We Collect',
      section1Body: 'To provide reservation, lookup, and cancellation services, we collect the information you provide (e.g., name, student ID, email) and non-personal statistics such as page view counts.',
      section2Title: '2. Purposes of Use',
      section2Body: 'Your data is used only for: activity reservations and notifications, reservation lookup and cancellation, violation and blacklist management, system operation and analytics, and where required by law. We do not use your personal data for other purposes.',
      section3Title: '3. Retention and Security',
      section3Body: 'We retain data in accordance with operational needs and applicable laws, and take appropriate technical and organizational measures to protect your data from unauthorized access, alteration, or disclosure.',
      section4Title: '4. Your Rights',
      section4Body: 'You may exercise your rights under applicable data protection law (e.g., access, correction, deletion). Please contact the EMI Center for requests. If you do not provide required data, we may not be able to provide reservation and related services.',
      section5Title: '5. Policy Updates',
      section5Body: 'We may update this policy from time to time. Changes will be posted on this page; we will notify you of material changes where appropriate.',
    },
    termsPage: {
      title: 'Terms of Use',
      lastUpdated: 'Last updated: March 2026',
      intro: 'By using the EMI Center English Enhancement Activity Reservation System (EEARS), you agree to these terms of use. Please read them carefully.',
      section1Title: '1. Service Description',
      section1Body: 'This system provides online reservation, lookup, and cancellation for English enhancement activities (e.g., English Table, English Club, International Forum). Services are intended for university students and other persons as announced by the Center.',
      section2Title: '2. Your Obligations',
      section2Body: 'You must provide accurate and complete information and must not impersonate others. If you cannot attend a reserved activity, you must cancel at least 2 hours before the start. No-show, late arrival beyond the allowed time, or leaving without a valid reason may be recorded as violations and may result in blacklisting.',
      section3Title: '3. Violations and Blacklist',
      section3Body: 'Two violations in the same semester result in a two-week blacklist during which you cannot make reservations. Violations include no-show, leaving without a valid reason, and arriving after the allowed time. Details are as announced by the Center.',
      section4Title: '4. Intellectual Property and Use',
      section4Body: 'The system, interface, content, and logos are owned by the Center or the University unless otherwise stated. You may use the system only in compliance with these terms and Center rules. You may not reverse engineer, scrape, disrupt the service, or infringe others’ rights.',
      section5Title: '5. Disclaimer and Changes',
      section5Body: 'The system is provided as is. The Center is not liable for interruption or data loss due to force majeure, maintenance, or network issues. The Center may revise these terms; revisions will be posted here, and continued use constitutes acceptance.',
    },
    page: {
      myReservationsTitle: 'My Reservations',
      myReservationsLead: 'These are the reservations for your signed-in account. Cancelling still needs the code from your booking email.',
      activitiesLead: 'See what each activity does, who it fits, and how it usually works before choosing an open session from the calendar.',
      activityCategoryLead: 'Calendar and reservation entry for this activity type.',
      calendarBookingTitle: 'Calendar Booking',
      etTopicsCta: 'Semester topics',
      calendarBookingLead: 'Pick a session from the calendar to reserve or manage your reservations.',
      comingSoon: 'Coming Soon',
      bestepLabel: 'BESTEP',
      bestepComingSoon: 'BESTEP is coming soon.',
      calendarCtaToActivities: 'Learn activity types → Activity Intro',
      eventTypeFilterAll: 'All sessions',
      calendarInsightsAria: 'Calendar session summary and status legend',
      calendarSummaryBookable: '{{count}} open for booking',
      calendarSummaryTotal: '{{count}} total',
      calendarJumpNext: 'Jump to next open session',
      calendarJumpNearest: 'View nearest session',
      calendarJumpNone: 'No open sessions right now',
      calendarNoBookableHint: 'No sessions open for booking right now. You can still browse announced sessions.',
      calendarListNoEventsInRange: 'No sessions in this date range',
      calendarLegendTitle: 'Status',
      calendarLegendFull: 'Full',
      calendarLegendClosed: 'Not open / closed',
      reservationLookupTitle: 'Check Reservations',
      reservationStudentId: 'Student ID',
      reservationName: 'Name',
      reservationEmail: 'Email',
      reservationSearch: 'Search',
      reservationClose: 'Close',
      reservationNoRecords: 'No matching reservation records found',
      reservationEvent: 'Event',
      reservationDate: 'Date',
      reservationTime: 'Time',
      reservationCancel: 'Cancel',
      reservationCancelBtn: 'Cancel Reservation',
      reservationVerifyCode: 'Verification Code',
      reservationVerifyPlaceholder: 'Enter verification code',
      reservationVerifyHint: 'Enter the code from your confirmation email',
      reservationConfirmCancel: 'Confirm Cancel',
      reservationCancelBack: 'Cancel',
      reservationCannotCancel: 'Cannot Cancel',
      reservationCancelDeadline: 'Cancel deadline',
      reservationSearchHint: 'Search uses your signed-in account.',
      surveyEmptyTitle: 'No surveys are open right now',
      surveyEmptyDesc: 'You can still browse sessions. If booking asks for a survey, complete it when prompted.',
      surveyEmptyCtaEvents: 'Browse sessions',
      surveyEmptyCtaActivities: 'Learn activity types',
      courseGuideStatusTitle: 'This page explains graduation rules, not your personal records',
      courseGuideStatusLead: 'For reservations, passport points, and certification progress, go to My English Progress. BESTEP registration is a separate process.',
      courseGuideStatusCtaProgress: 'My English Progress',
      courseGuideStatusCtaPassport: 'English Learning Passport',
      courseGuideStatusCtaBestepNote: 'BESTEP registration',
      courseGuideStatusBestepHint: '(Optional program — not the graduation certification itself)',
      studentProgressTitle: 'My English Progress',
      studentProgressLead: 'After you sign in, this page summarizes your activities, courses, exams, and passport points (based on data imported into this system).',
      studentProgressEmptyTitle: 'No learning records yet',
      studentProgressNotFound: 'This account does not have activity, course, or exam records yet. New reservations and imported records will show up here.',
      studentProgressLoadError: 'Could not load progress. Please try again later.',
      studentProgressTotal: 'Total reservations: ',
      studentProgressNextUpcoming: 'Next upcoming',
      studentProgressRecentActivities: 'Recent 3 sessions',
      studentProgressNoUpcoming: 'No upcoming reservations.',
      studentProgressNoRecent: 'No past activity records yet.',
      studentProgressAttendedBadge: 'Attended',
      studentProgressNoShowBadge: 'No-show',
      studentProgressUpcomingBadge: 'Upcoming',
      studentProgressPendingBadge: 'Pending',
      studentProgressCourses: 'Course records (imported)',
      studentProgressExams: 'Exam records (imported / registration)',
      studentProgressEnglishTestRegs: 'English test registration',
      studentProgressBestepScores: 'BESTEP scores',
      studentProgressBestepAttendance: 'BESTEP attendance',
      studentProgressBestepAttended: 'Attended',
      studentProgressBestepAbsent: 'Absent',
      studentProgressTotalScore: 'Total',
      studentProgressReservations: 'Activity reservations',
      studentProgressReservationsCount: '{{count}} record(s)',
      studentProgressReservationsEmpty: 'No reservations found',
      studentProgressElpPoints: 'Passport points',
      studentProgressElpEmpty: 'No passport yet',
      studentProgressElpApply: 'Go to English Learning Passport',
      studentProgressElpOptionalLink: 'Learn about the passport certification path',
      studentProgressAttended: 'Attended: ',
      studentProgressNoShow: 'No-show: ',
      studentProgressUpcoming: 'Upcoming: ',
      studentProgressCertPath: 'Certification Path',
      studentProgressCertStepCourse: 'English Course',
      studentProgressCertStepTest: 'English Test',
      studentProgressCertStepPassport: 'Passport 100 pts',
      studentProgressCertHint: 'Graduation English certification: test score or 100 passport points. See course guide.',
      studentProgressCertCta: 'Course & certification guide',
      homeOverlayClose: 'Skip animation and continue',
      eventsStickyMyReservations: 'My reservations',
      eventsStickyHint: 'Already booked? Sign in with the campus portal before you look up or cancel (the deadline depends on the activity type).',
      reservationResultNextHint: 'Cancel before that activity’s deadline. The deadline depends on the activity type. You can also book another session.',
      reservationResultBookAnother: 'Book another session',
      reservationResultProgress: 'My English Progress',
      englishTestNotGraduation: 'This is BESTEP registration, not a graduation certification lookup.',
      englishTestOfficialAnnouncementLink: 'Open full announcement on Siwan College site',
      englishTestOfficialAnnouncementHint: 'Official rules, rewards, and deadlines apply on the college website. We recommend reading it before continuing.',
      englishTestAnnouncementNextHint: 'Please confirm you have read the registration notice before continuing.',
      englishTestAnnouncementNext: 'Next →',
      englishTestPrivacyNextHint: 'Please agree to the privacy notice before continuing.',
      englishTestProgressLink: 'My English Progress',
      englishTestCourseGuideLink: 'Course & certification guide',
      reservationResultTitle: 'Results',
      reservationBadgeCancelable: 'Cancellable',
      reservationBadgeLocked: 'Cancel locked',
      reservationBadgeCanceling: 'Confirming cancel',
      reservationCardStatusAria: 'Reservation status',
      eventTypeFilterGroupAria: 'Activity categories',
      eventTypeFilterCurrentSuffix: ' (selected)',
    },
    weekly: {
      title: 'EEARS Weekly',
      kicker: 'EEARS Weekly',
      pageLead: 'Weekly updates, learning tips, and a vocabulary challenge.',
      issueLabel: 'Issue {{issue}}',
      defaultHeadline: 'Welcome to this week\'s EEARS Weekly.',
      tipLabel: 'Learning tip',
      editorialTitle: 'Editor\'s note',
      readFull: 'Read full issue',
      later: 'Maybe later',
      loadError: 'Weekly issue could not be loaded. Please try again.',
      empty: 'No published weekly issue yet.',
      bookCta: 'Book activities',
      activitiesCta: 'Browse activities',
      challengeTitle: 'Weekly vocabulary challenge',
      challengeKicker: 'Weekly challenge',
      challengeIntro: 'Group 16 words into 4 sets of related vocabulary. Select 4 words and submit; the round ends after 5 mistakes or when time runs out.',
      challengeStart: 'Start challenge',
      challengeWon: 'You completed this week\'s challenge!',
      challengeLost: 'Challenge ended — try again anytime.',
      challengeStats: '{{mistakes}} mistake(s) used',
      challengeRetry: 'Play again',
      challengeBook: 'Book a session',
      challengeUnavailable: 'This week\'s challenge is not configured yet.',
      challengeGridAria: 'Vocabulary challenge tiles',
      archiveTitle: 'Past issues',
      previewTitle: 'Weekly preview',
      previewBanner: 'Preview only — this issue may not be published yet.',
      previewError: 'Preview link is invalid or expired.',
      previewDraft: 'Draft',
      pollLoading: 'Loading poll…',
      pollLoadError: 'Could not load poll',
      pollVoteError: 'Vote failed',
      pollSubmit: 'Submit vote',
      pollSubmitting: 'Submitting…',
      pollThanks: 'Thanks for voting!',
      pollTotalVotes: '{{count}} vote(s) total',
      quizFillPlaceholder: 'Your answer',
      quizSubmit: 'Submit answers',
      quizSubmitting: 'Submitting…',
      quizSubmitError: 'Submit failed',
      quizCorrect: 'Correct',
      quizWrong: 'Not quite',
      quizScore: 'Score: {{correct}} / {{total}}',
      shareResult: 'Share result',
      shareCopied: 'Share text copied',
      readComplete: 'Read',
    },
  },
};

export const getTranslation = (lang, path) => {
  const keys = path.split('.');
  let value = translations[lang] || translations.zh;
  for (const key of keys) {
    value = value?.[key];
    if (value === undefined) return path;
  }
  return typeof value === 'string' ? value : path;
};
